webpackJsonp([1],{

/***/ "0die":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingPureToneTestHeadphone"}},[_c('div',{staticClass:"HearingTest-test--part"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.started),expression:"!started"}],staticClass:"info-help"},[_c('div',{staticClass:"HearingTest-test--part"},[_c('div',{staticClass:"HearingTest-test--title"},[_vm._v("تست تون خالص")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--text"},[_vm._v("این تست آهسته ترین صداهایی که یک شخص در فرکانس های مختلف میتواند بشنود را مشخص میکند.")]),_vm._v(" "),_c('button',{staticClass:"HearingTest-test--button",staticStyle:{"display":"block","float":"none","margin":"0px auto"},on:{"click":function($event){_vm.startTest()}}},[_c('span',[_vm._v("شروع تست")]),_vm._v(" >")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.started),expression:"started"}]},[_c('div',{staticClass:"HearingTest-test--title "},[_c('icon',{attrs:{"name":"volume-up"}}),_vm._v("گوش "+_vm._s(_vm.earSide === 'L' ? 'چپ' : 'راست'))],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--calibrationContainer"},[_c('div',{staticClass:"HearingTest-test--volumeContainer"}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubbles"},[_c('div',{staticClass:"HearingTest-test--playButtonContainer"},[_c('div',{staticClass:"HearingTest-test--frequency",attrs:{"data-frequency":"ptFrequency1"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingTone),expression:"loadingTone"}]},[_c('icon',{attrs:{"name":"spinner","pulse":""}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingTone),expression:"!loadingTone"}]},[_vm._v(_vm._s(_vm.currTone)),_c('br'),_c('span',{staticStyle:{"font-size":"22px"}},[_vm._v("HZ")])])])]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"31px","margin-top":"92px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"53px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"11px","margin-top":"-26px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"72px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"-4px","margin-top":"-34px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"87px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"-11px","margin-top":"-36px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"94px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"-8px","margin-top":"-37px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"93px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"1px","margin-top":"-36px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"83px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"18px","margin-top":"-30px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"65px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"41px","margin-top":"-23px"}})]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeContainer"})]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nextBtn),expression:"!nextBtn"}],staticClass:"HearingTest-test--toneButton ng-binding",on:{"click":function($event){_vm.nextTest()}}},[_vm._v("بله")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.nextBtn),expression:"nextBtn"}],staticClass:"HearingTest-test--toneButton red ng-binding",on:{"click":function($event){_vm.startTest()}}},[_vm._v("بعدی!")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HearingTest-test--text"},[_vm._v("وقتی صدا را شنیدید بر روی "),_c('strong',[_vm._v("بله")]),_vm._v(" کلیک کنید")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0nfB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingPureToneTestSpeaker_vue__ = __webpack_require__("CDV8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ab4270_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingPureToneTestSpeaker_vue__ = __webpack_require__("9Ybn");
function injectStyle (ssrContext) {
  __webpack_require__("wx6w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73ab4270"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingPureToneTestSpeaker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ab4270_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingPureToneTestSpeaker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1YkD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "35rQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue__ = __webpack_require__("HqHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e897b6_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_steps_vue__ = __webpack_require__("z655");
function injectStyle (ssrContext) {
  __webpack_require__("Kwe6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24e897b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e897b6_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "42Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DK6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0ce8e6c_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("MRRG");
function injectStyle (ssrContext) {
  __webpack_require__("sSgv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0ce8e6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0ce8e6c_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5KHr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5onB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps_vue__ = __webpack_require__("35rQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HearingCalibrationHeadphone_vue__ = __webpack_require__("SbS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HearingCalibrationSpeaker_vue__ = __webpack_require__("ZOtf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingCalibration',

    components: {
        HearingSteps: __WEBPACK_IMPORTED_MODULE_0__steps_vue__["a" /* default */],
        Headphone: __WEBPACK_IMPORTED_MODULE_1__HearingCalibrationHeadphone_vue__["a" /* default */],
        speaker: __WEBPACK_IMPORTED_MODULE_2__HearingCalibrationSpeaker_vue__["a" /* default */]
    },
    mounted: function mounted() {
        // check user passed prev steps, if not go home!
        if (!window.questionsAnswer) this.$parent.$router.replace('/');
    },
    data: function data() {

        return {
            loaded: false,
            speaker: 'بلندگو',
            headphone: 'هدفون',
            calibrationType: '',
            calibrations: {},
            currCount: 1,
            answers: []
        };
    },

    watch: {
        calibrationType: function calibrationType(val) {
            window.calibrationType = val;
        }
    }
});

/***/ }),

/***/ "6eFg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1000R.1f6c9af.mp3";

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9FTF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.clazz,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path){return _c('path',_vm._b({},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon){return _c('polygon',_vm._b({},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.icon.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Ybn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingPureToneTestSpeaker"}},[_c('div',{staticClass:"HearingTest-test--part"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.started),expression:"!started"}],staticClass:"info-help"},[_c('div',{staticClass:"HearingTest-test--part"},[_c('div',{staticClass:"HearingTest-test--title"},[_vm._v("تست تون خالص")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--text"},[_vm._v("این تست آهسته ترین صداهایی که یک شخص در فرکانس های مختلف میتواند بشنود را مشخص میکند.")]),_vm._v(" "),_c('button',{staticClass:"HearingTest-test--button",staticStyle:{"display":"block","float":"none","margin":"0px auto"},on:{"click":function($event){_vm.startTest()}}},[_c('span',[_vm._v("شروع تست")]),_vm._v(" >")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.started),expression:"started"}]},[_c('div',{staticClass:"HearingTest-test--title "},[_c('icon',{attrs:{"name":"volume-up"}}),_vm._v("دوطرف ")],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--calibrationContainer"},[_c('div',{staticClass:"HearingTest-test--volumeContainer"}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubbles"},[_c('div',{staticClass:"HearingTest-test--playButtonContainer"},[_c('div',{staticClass:"HearingTest-test--frequency",attrs:{"data-frequency":"ptFrequency1"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingTone),expression:"loadingTone"}]},[_c('icon',{attrs:{"name":"spinner","pulse":""}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingTone),expression:"!loadingTone"}]},[_vm._v(_vm._s(_vm.currTone)),_c('br'),_c('span',{staticStyle:{"font-size":"22px"}},[_vm._v("HZ")])])])]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"31px","margin-top":"92px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"53px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"11px","margin-top":"-26px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"72px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"-4px","margin-top":"-34px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"87px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"-11px","margin-top":"-36px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"94px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"-8px","margin-top":"-37px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"93px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"1px","margin-top":"-36px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"83px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"18px","margin-top":"-30px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"65px","margin-top":"-17px"}}),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBubble",staticStyle:{"margin-right":"41px","margin-top":"-23px"}})]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeContainer"})]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nextBtn),expression:"!nextBtn"}],staticClass:"HearingTest-test--toneButton ng-binding",on:{"click":function($event){_vm.nextTest()}}},[_vm._v("بله")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.nextBtn),expression:"nextBtn"}],staticClass:"HearingTest-test--toneButton red ng-binding",on:{"click":function($event){_vm.startTest()}}},[_vm._v("بعدی!")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HearingTest-test--text"},[_vm._v("وقتی صدا را شنیدید بر روی "),_c('strong',[_vm._v("بله")]),_vm._v(" کلیک کنید")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A7hb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/500L.7cb2d7b.mp3";

/***/ }),

/***/ "AcTv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingCalibrationHeadphone"}},[_c('div',[_c('div',{staticClass:"HearingTest-test--text"},[_c('div',{staticClass:"HearingTest-test--title"},[_c('icon',{attrs:{"name":"volume-up"}}),_c('span',[_vm._v(" کالیبراسیون صوتی گوش "+_vm._s(_vm.earSide === 'left' ? 'چپ' : 'راست'))])],1),_vm._v(" "),_c('div',{attrs:{"ng-if":"!displayComfortText"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curCalibration == 'first'),expression:"curCalibration == 'first'"}],staticClass:"HearingTest-test--text"},[_c('strong',[_vm._v("بر روی گزینه اجرا کلیک کنید")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curCalibration == 'second'),expression:"curCalibration == 'second'"}],staticClass:"HearingTest-test--text"},[_c('strong',[_vm._v("بر روی گزینه اجرا کلیک کنید")]),_vm._v(" "),_c('br'),_vm._v(" صدا را تنظیم کنید تا جاییکه "),_c('strong',[_vm._v("به سختی")]),_vm._v(" بتوانید صدا را بشنوید.\n          "),_c('br'),_vm._v("در مورد تشخیص مواردی که گفته میشود نگران نباشید، لطفا فقط تمرکز کنید که آیا صدایی وجود دارد یا نه؟\n        ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curCalibration == 'first'),expression:"curCalibration == 'first'"}],staticClass:"HearingTest-test--calibrationContainer clearfix",attrs:{"id":"firstCalibration"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{staticClass:"HearingTest-test--volumeContainer",on:{"click":function($event){_vm.lowerVolume(5,6)}}},[_c('div',{staticClass:"HearingTest-test--volumeControlContainer"},[_c('div',{staticClass:"HearingTest-test--volumeControl"},[_c('icon',{attrs:{"name":"minus-circle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeButton ng-binding"},[_vm._v("ملایمتر")])])]),_vm._v(" "),_c('v-flex',{staticClass:"play-volume",attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{staticClass:"HearingTest-test--spinner"},[_c('div',{staticClass:"HearingTest-test--playButtonContainer",class:{'Active': _vm.showVolumeAdjusters}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showVolumeAdjusters),expression:"!showVolumeAdjusters"}],staticClass:"HearingTest-test--playButton",on:{"click":function($event){_vm.audioCalibrationPlay()}}},[_c('span',{staticClass:"play-icon"},[_c('icon',{attrs:{"name":"play"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volume"},[_vm._v(_vm._s(_vm.currVol)+"%")])]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBar",class:{'Active': _vm.showVolumeAdjusters}})])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{staticClass:"HearingTest-test--volumeContainer",on:{"click":function($event){_vm.raiseVolume(5,96)}}},[_c('div',{staticClass:"HearingTest-test--volumeControlContainer"},[_c('div',{staticClass:"HearingTest-test--volumeControl"},[_c('icon',{attrs:{"name":"plus-circle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeButton"},[_vm._v("بلندتر")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--textButton",on:{"click":function($event){_vm.nextCalibrationPart()}}},[_c('span',[_vm._v("ادامه   >")])])])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curCalibration == 'second'),expression:"curCalibration == 'second'"}],staticClass:"HearingTest-test--calibrationContainer clearfix",attrs:{"id":"secondCalibration"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volumeContainer",on:{"click":function($event){_vm.lowerVolume(1,1)}}},[_c('div',{staticClass:"HearingTest-test--volumeControlContainer"},[_c('div',{staticClass:"HearingTest-test--volumeControl"},[_c('icon',{attrs:{"name":"minus-circle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeButton ng-binding"},[_vm._v("ملایمتر")])])]),_vm._v(" "),_c('v-flex',{staticClass:"play-volume",attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{staticClass:"HearingTest-test--spinner"},[_c('div',{staticClass:"HearingTest-test--playButtonContainer",class:{'Active': _vm.showVolumeAdjusters}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showVolumeAdjusters),expression:"!showVolumeAdjusters"}],staticClass:"HearingTest-test--playButton",on:{"click":function($event){_vm.audioCalibrationPlay()}}},[_c('span',{staticClass:"play-icon"},[_c('icon',{attrs:{"name":"play"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volume"},[_vm._v(_vm._s(_vm.currVol)+"%")])]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBar",class:{'Active': _vm.showVolumeAdjusters}})])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volumeContainer",on:{"click":function($event){_vm.raiseVolume(1,_vm.MaxVol)}}},[_c('div',{staticClass:"HearingTest-test--volumeControlContainer"},[_c('div',{staticClass:"HearingTest-test--volumeControl"},[_c('icon',{attrs:{"name":"plus-circle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeButton"},[_vm._v("بلندتر")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--textButton",on:{"click":function($event){_vm.nextCalibrationPart()}}},[_c('span',[_vm._v("ادامه")]),_vm._v("  >")])])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("صدا را کم و زیاد کنید تا جاییکه احساس کنید سطح شنیداری صدا برای شما "),_c('strong',[_vm._v("راحت و مناسب")]),_vm._v(" است.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BUbc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAYAAADFniADAAAGx0lEQVRYhbWYe4xcVR3HP79z78zO7Hb20U5322VnuxtadmGrgK9KtVTS0GrZVKOmkRAhgBhiohEtGjQmIliLCon6h6b8oVHRGqlBYxBjhYC2WvrAEJYFsULdF223+5jZxzzuPcc/7szsnbl3ZrcYv8nJzD3nd37nex6/8/v9jvD4cWpCQuoMDcD1CNcBVwE9QBcQB3LAOHAWGMZwEngaSCOAKeo0VfoNFbBrMwqgF/gswm6gr6aUYT3CO32DngWOAN8HXlzJQLKClUoC+4C7gZaVKK2BHPAY8ACGN3z6AyulllG0GzgKfBlowRhwXCi4oM0yXavgbfsdwN+B2+qJ1iN1L/B74AoAtMEWxUe7k9yxcR2ppgZw9MpJLZ3PDoSfIHyv1vjhZ0p4EPhq+dvAKtvi8es2savD28GJbIHBo69yemoOrOUWPBSfA1qB24GK2QW1CfeWCZV2yHG5qbOtTAhgfSzCNzen3goZP24FflBdWU1qJ/CQj2AZqXg0oPGyWASUChzUS8RngE8hxfGkktRqhB8CEhhECUcvZgLajpxPg6vD77MwmKrfEoSHgU2lT4u9d5Uavg4MFv8HSI3O5TiXdxhojlMwhsPj0+x78SwFpD4pV4PWnrVWFxGvQAPQjeGQN/zh4wDdwDDQWDGr8j1iPOUGGmMRokqYyRY8xZYCVYOVMWxLNtPb1FC1MJDThmcnM0ws5Pz93w8ctYuDf76CUKmnMeBommIRtrS3cHJmnnS2wIIIKGHHulZOzcwzM5+HiCrN2oOj2bshya+2bKy5iEPpRbY+M0Tacb2+hi8BH1bFpdsTNsuOWJTvXNPDCzs28+dt/Tx6bW9xQJdPpJIc2dbPiRsGuG+gi2Q0UnmhGsPO9voOYKA5zuaWRnBNaSFuQNhgA9uAyyu2C8A19Cdi7OtbX67a27Wa5/sv46mJaQ6+oweAjati7H9bCiNw4KVRiFr+mdUlBQHzTwAfUsD7iiwDelwTVPqtgS6e+8BVJGyrot6W4LlSIXXVkKDMexTClZVS9ZVElLA6GnQEJqTvS+nFuroyjsu/57LVhtJn48VD/xc88s8Jopbi6kSczsYo1ycTPPXmLJmCQ9YYDo1MMbaQq3ZT7TaGrvJnjVBixTDFog2DqTW8q62JQyMXOXB+ll297WScDgafHfatqIAd8HTNNlJ1FfjJvRW4mi/2d/Ldt3cD8JW+TgaPvcrw7CJ3v/AGWOK5ptqwFZD9HyhUwYCBm1NryjURJdzV285/ZhcYnc8tRwjAVcBEmG4AawXWU4IlAq5mR2crfYlYRdv2ZIJNbU2Vx6L2EZlTUAxN/RBACSPzOV5exoJKuJArsDYR5wub1vGxY6/x18kMk3mHX45c5M5Tr3P/QBcxWwWThhBVwuHj+4H7Qpu1odFS3LIhybc3d9Mataqb+fXYFD/615scm5oHJTRawnvbVvFyZhExBttSXN7UwMnpeWYcjQ65+6rwmA3UzhyUsKA1jw6Ps6VtFXf2rq1oHs/mueXEGdy8A7YFBU1HQwO/23oFacdlMlcgFW9gztV0P/kPtNaV/jEcpxVeXjZWU0QELMVQJriN53MOWhuPkABas2d9GxElrIna9CXiNNqKtQ0217T6fFxtZIE/KAwZ4I91RQXGFguB6nPZAsb1hdci3NjeHNadnR3NXtRRH38DhlUxY30EcMpNIZHneDYf0DC6mPcGEkAbeprj3NgRHhncnFpDJGovZ4EPA6hiwxBeorg0tSqczxXIV+V6r8/7rjhX88GOFhprZDZXJuJc29rkRaHh4/wFeBLA9jV8DbgJLyOuNF0RJvMOaccl6XPGp2cWllQqhQZ+fHaShG3xkc5WbBEWXc1vxqcpaMPqKuv1wcXLwo1HagkjwD3AzwKzECFd8KypRMo1hrFsfsnDW8LBM+c4+Mo47Yk4u9ddjW0J03mHW0+cQeddLzoNX8n7MTxfnl9V48/xHiICcBzNRHbpsM85mgs5p9LERcC2aPI5WcFLZLFVrevgtyAHykmESPFMVZZ7gJ8GumrNsO92z2nNbMGtlCnlbUL5bDVHrHr+/Wngk2AKfgJhabvGcDvCHF6iWHY7vxidYq54BYwu5Mm6OpjJCEwXXB58ZZyo8rY9W0qnKt+nnkC4DQgklPWfguDTCA/h5fye5SwF+d6lGQaD9zoTLucA38CwH8EN9GX5p6CDwFbgsCetIGJ5pRahEpFwuWeA7RgegHBCKyEFXpL6cQzbgSeA9Ar6+JHFe8nbA+wAji3X4VKeF58rlh4MuxDeDfQDHUACQ6S4HRngAvAacAr4E4ahS4lm/wtfwFY0AWnR/AAAAABJRU5ErkJggg=="

/***/ }),

/***/ "BW0t":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAE9klEQVRoge3YSahcRRQG4K/6dWKMszFRcchCYqJxQIMoulMRUUEUXAgqOC4EUXShSwdwpRt1Zdy4SRYaxGHjCA4IDxRExBkjxuAYhxgymLxXLup233ur63Y/5JFV/9D0rapTp/5Tdeqccy9TTDHFFFNM8f8RbJlNT3Gs3BG4F7cJlovmqtlpXvO/S1co9MVsrG4PNL6Gh/FTJ7Nq3f5Y+gkzuAOPjSxeIpyTG/TFQt+4eal9l8Txfvzdks82ZtSQUYKn4M5q4n78ijn0hrJNkvnOTzqppkysWlHE8TgEt+JZzHbM7jBkFKcLzqiW+FhwLYKoX3SXJuGg7Xb5JuWumebOC3aKNgpuFAWsbxlSWHeSIUtwfvV8QPCWdCIHA5txmWCV6ArBS/iz61R7Y1UFK3FD1dqGFxaP5xgksm/jl6rnOpw0bkrTkCWN3+CkThOGJ/IbPl0kqt0Iw99u0VeVUUtxdsV3JuPaUxFegZtxjNpT56v/DVXPPD5o+WZ+uXNfz+9DHrXykF2+by8ILhUdi7txphRweo1Zu/FKsGX2SdxnvJttE10v+KhTYpIheV9uSK4r4RDBrOjc4ZzSmrzRE92G3jCMjioj+gQfTUiai4ea8D582OKUR72ES/qCF3E1ThwKN4VSe69gjeg43dlgcZHW3yXahd1VRVGj9oA/8H6wZXYGl4uuwnlYLTg1m7IH+8WqeChhMV2rxnyl+wjpkg/wu+BbfI1X8XZfytKvV7+jsJHKkLRQwPLh4oP+nGDTmBLxfHxcxs9lRmu673CL6JuBbB5+b8HFxV1t+mdXxMpJ5Rm+NB6z8XytUgkUrRPdjuMGcgNDDhM8g6cMEk+XC0xyjVKIXuh4vkGlDUvtI/Gg4HmsFpMhS/GIujCsMe7I8/58B3ODu04tZPKMnkBzTlvXVXgah/dxMu4ZXuRgG97BiaJzcEJLeU6syzW6UCrzm+0uw4M/8Lloq5So10kV+JW4uC9apX6V+QcPCTaJVmC9aJ1gTWXQWtFZOLRIMI9Kzf6FGFHLR9GXUkn0k2ArPscX2C7YgJela9DDun5lwqAk2YN3qwV3CN4TvVeNzVQTL8ED2NDawS6i44wo3bdgOx4XvInvpZIk35SPpSL2pMrsuT7mxUplUtjer5roHH7AD4J/8WLR10un0oX8fqT5m/Ac/s3I5xswU+mIgvl+tvhywTWizcqevh/Hii4vhtSuYFG6W/l4bcwGwVop2S0d0ZrkLpQS97Cvnwkdjkdx03BKe+E5wdFSFTo5M+fkS+1cNlW7mwU7xCo9jEax1QY5pOrvtwQS9ZXSC9XCqqo8eo0zZpKOmsP6zvDdsU59IuMu6qR2F8nSHcqfx8l2cSms12sJjhPOI1OzfyFukyMf7ypjBuO5oZmOfovMOAOaz13H3GVMiUQp32TkRriV+qrnXlGw7a9tUnmiy/0/P518fimS5SRLz11VRIVea4GCpS2lk3w3J9C1QbnO0lhJX/M524D+iLJRoTnRZ4LPpC9/ZWULuZwl/SW3q9v7pdLoIhxaDBgj4betoHlCe6sE+YT0MftgYh8uwCaD14uOzei3OrtzwT6pRPlr8bmOQeK1RygE3Oz0e1VtNdPpCnH4znJwUVNfKha+8rTR60sF4I+iZUPR+viWYKfmJ/1SpFlstPXvFfyMZaK9mWTAAelLyxRTTDHFFFNM8R87ZcNrarxq0AAAAABJRU5ErkJggg=="

/***/ }),

/***/ "CDV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
            name: 'HearingPureToneTestSpeaker',
            props: ['starting'],
            components: {},
            created: function created() {

                        this.curAudio = this.tones[500];
            },
            data: function data() {

                        return {
                                    started: false,
                                    curAudio: null,
                                    tones: {
                                                500: new Audio(window.pure_tone.tone500),
                                                1000: new Audio(window.pure_tone.tone1000),
                                                2000: new Audio(window.pure_tone.tone2000),
                                                4000: new Audio(window.pure_tone.tone4000)
                                    },
                                    currTone: 500,
                                    curCounterTone: 0,
                                    answers: [],
                                    intervals: null,
                                    passed: 1,
                                    timeCounter: 0,
                                    loadingTone: true,
                                    test: 0,
                                    nextBtn: false,
                                    answered: false

                        };
            },

            methods: {
                        startTest: function startTest() {

                                    var self = this;

                                    this.started = true;

                                    clearInterval(this.intervals);
                                    this.curAudio.volume = 0;
                                    this.curAudio.pause();

                                    this.curAudio.currentTime = 0;

                                    this.timeCounter = 0;

                                    this.intervals = setInterval(function () {
                                                //let volPlus = ((self.curCounterTone <= 1) ? window.calibrationAnswers.data.second :window.calibrationAnswers.data.first)/ 100;
                                                var volPlus = (window.calibrationAnswers.data.first - window.calibrationAnswers.data.second) / 100;

                                                var volume = volPlus + (self.curCounterTone > 1 ? self.curCounterTone - 1 : 0) / 20;

                                                volume = volume > 1 ? 1 : volume;
                                                self.curAudio.volume = volume;
                                                self.curAudio.play();
                                                //console.log(volPlus,window.calibrationAnswers.data.first , ((self.curCounterTone -1)),volume);

                                                self.test += 1;

                                                if (self.curAudio.readyState <= 2) return false;

                                                self.checkAudioForPlay();
                                    }, 100);
                        },
                        checkAudioForPlay: function checkAudioForPlay() {
                                    this.loadingTone = false;

                                    this.nextBtn = false;
                                    // if timeCounter is 0 so play this audio
                                    if (this.timeCounter === 0) {
                                                this.playAudio();
                                    }

                                    // plus timeCounter
                                    this.timeCounter += 100;

                                    // if 3 seconds is done. so next audio
                                    if (this.timeCounter >= 3000) {
                                                this.timeCounter = 0;
                                                return false;
                                    }
                        },
                        playAudio: function playAudio() {

                                    this.curAudio.volume = 0;
                                    //console.log(window.calibrationAnswers.data.first/100 ,((this.curCounterTone -1) / 10),window.calibrationAnswers.data.first,this.curCounterTone );
                                    this.curAudio.pause();
                                    this.curAudio.volume = 0;
                                    this.curAudio.currentTime = 0;
                                    if (this.currTone === 4000 && this.curCounterTone === 4) {
                                                if (!this.answered) this.answers.push({
                                                            'tone': this.currTone,
                                                            'answer': 0
                                                });
                                                this.saveAndNextStep();
                                                return false;
                                    }
                                    if (this.curCounterTone === 4) {
                                                this.loadingTone = true;
                                                this.nextBtn = true;

                                                if (!this.answered) this.answers.push({
                                                            'tone': this.currTone,
                                                            'answer': 0
                                                });

                                                this.answered = false;
                                                this.currTone *= 2;
                                                this.curAudio = this.tones[this.currTone];

                                                this.curCounterTone = 0;
                                    }
                                    //let volume = window.calibrationAnswers.data.second/100;
                                    //volume = volume > 1 ? 1 : volume;

                                    // console.log(this.curAudio.volume,window.calibrationAnswers.data.first,volume);

                                    //this.curAudio.volume = volume;
                                    this.curAudio.play();
                                    this.curCounterTone++;
                        },
                        nextTest: function nextTest() {
                                    this.answered = true;
                                    this.loadingTone = true;
                                    // mines 1 because  this.curCounterTone is always plussed 1
                                    ///console.log("called! nextTest -->  ",this.currTone,this.answers);

                                    this.answers.push({
                                                'tone': this.currTone,
                                                'answer': this.curCounterTone
                                    });

                                    this.curCounterTone = 4;

                                    this.startTest();
                        },

                        /**
                         * all tests done go next STEP
                         */
                        saveAndNextStep: function saveAndNextStep() {

                                    clearInterval(this.intervals);

                                    window.PureToneAnswers = this.answers;
                                    this.$parent.$router.replace('/speech_test');
                        }
            }
});

/***/ }),

/***/ "CJl+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingPureToneTest"}},[_c('HearingSteps',{attrs:{"current-step":"Pure_tone_test","dot-count":0,"currentDot":0}}),_vm._v(" "),_c('div',{attrs:{"id":"PureToneTest"}},[(_vm.audioType == 'headphone')?_c('Headphone',{attrs:{"starting":_vm.started}}):_vm._e(),_vm._v(" "),(_vm.audioType == 'speaker')?_c('speaker',{attrs:{"starting":_vm.started}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ccn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingPureToneTest_vue__ = __webpack_require__("xJDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ab993f_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingPureToneTest_vue__ = __webpack_require__("CJl+");
function injectStyle (ssrContext) {
  __webpack_require__("1YkD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60ab993f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingPureToneTest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ab993f_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingPureToneTest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_88f25b80_hasScoped_false_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("9FTF");
function injectStyle (ssrContext) {
  __webpack_require__("PceH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_88f25b80_hasScoped_false_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DK6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_RL_mp3__ = __webpack_require__("vXKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_RL_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_RL_mp3__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'IndexPage',
    data: function data() {
        return {
            start_exam: 'هم اکنون شنوایی خود را تست کنید!',
            start_btn: 'شروع تست',
            faq_items: [{
                id: 1,
                question: 'تفاوت بین تست شنوایی آنلاین پرشیاتون و ارزیابی شنوایی در مطب چیست؟',
                answer: '<p>تست شنوایی آنلاین، چگونگی تاثیر کم شنوایی بر زندگی شما را نشان میدهد، مثلا با مرور بر جنبه های مهم شنوایی و ارتباطات، تاثیر کم شنوایی بر روابط اجتماعی فرد را مشخص میکند.</p>\n' + '<p>ارزیابی و چکاب شنوایی در مطب، یک آنالیز کامل از میزان شنوایی و تاثیر آن بر ارتباطات اجتماعی شما را ارائه میدهد، این ارزیابی میتواند راه حلی برای بهبود شنوایی و زندگی تان فراهم کند.</p>'
            }, {
                id: 1,
                question: 'چگونه میتوانم دقیق ترین نتایج را حین انجام تست شنوایی آنلاین پرشیاتون بدست آورم؟',
                answer: '<p>به یک محیط آرام بروید، از هدفون استفاده کنید و تمرکز کنید، عجله نکنید و نگران نباشید، تست شنوایی آنلاین فرصتی برای بهبود موقعیت شخصی شماست.</p>'
            }, {
                id: 1,
                question: 'چگونه هر قسمت از نتایج تست شنوایی آنلاین پرشیاتون را تفسیر کنم؟هر قسمت چه معنی دارد؟',
                answer: '<p>تست شنوایی آنلاین به معنای جایگزینی برای یک ارزیابی کامل شنوایی توسط یک متخصص شنوایی نیست اما میتواند به شناسایی هرگونه مشکل شنوایی بالقوه که شما دارید کمک نماید.</p>\n' + '<p style="margin-right: 15px;">سوالات تجربی</p>\n' + '<p style="margin-right: 30px;">تجربه شخصی شما یکی از قوی ترین نشانه های وجود کم شنوایی بالقوه میباشد.</p>\n' + '<p style="margin-right: 15px;">نتایج تون خالص</p>\n' + '<p style="margin-right: 30px;">این یک تست مرسوم برای فهمیدن میزان حساسیت شما به صداهای مختلف میباشد.</p>\n' + '<p style="margin-right: 15px;">نتایج تست گفتاری</p>\n' + '<p style="margin-right: 30px;">نتایج این تست چگونگی کار کردن گوش و مغز باهم برای فهمیدن ارتباط شما با دیگران را نشان میدهد.</p>'
            }, {
                id: 1,
                question: 'وقتی یکبار تست شنوایی آنلاین پرشیاتون را کامل کردم، در مرحله بعد چه کاری باید انجام دهم؟',
                answer: '<p>بر اساس نتایج شخصی شما پس از تکمیل تست، ما پیشنهادات ویژه ای را برای مراحل بعدیتان به شما ارائه خواهیم کرد.</p>'
            }, {
                id: 1,
                question: 'یک ارزیابی شنوایی حرفه ای شامل چه مواردی میباشد؟',
                answer: '<p>\n' + '                            معاینه و دیدن گوش: با استفاده از اتوسکوپ، یک معاینه حرفه ای میتواند کانال گوش را از نظر نشانه هایی مانند انسداد و دیگر ابنورمالیتی ها بررسی کند.\n' + '                            <br>\n' + '                            تست تون خالص: این تست کمترین صداهایی که یک شخص با فرکانس هایی از پایین به بالا میتواند بشنود را معین میکند.\n' + '                            <br>\n' + '                            تست گفتاری: در اینجا از شما خواسته میشود که کلمات گفته شده مختلفی را در سطوح متفاوت بشنوید، تشخیص دهید و تکرار کنید.\n' + '                            <br>\n' + '                            تست گفتار در نویز: از شما خواسته میشود کلماتی که در محیط نویزی(پرسر و صدا) گفته میشوند را تکرار کنید.\n' + '                            <br>\n' + '                            تست های تعیین عملکرد گوش میانی: در طی این تست، متخصص مقادیر مختلفی از فشار هوا را در کانال گوش، برای ارزیابی وضعیت گوش میانی و پرده گوش مورد استفاده قرار میدهد.\n' + '                            <br>\n' + '                            تست گسیل های صوتی(OAE): این تست اطلاعاتی را در مورد عملکرد سلول های مویی خارجی فراهم میکند.\n' + '                            <br>\n' + '                            تاریخچه گیری: سوال کردن در مورد تاریخچه شخصی شما شامل: تاریخچه پزشکی، داروهای مصرفی، تاریخچه خانوادگی و وضعیت شنوایی شما، به متخصص شنوایی اجاره میدهد که نیاز های اصلی شما را بهتر شناسایی کند.\n' + '                            <br>\n' + '                            ارزیابی نیازهای ارتباطی: ارزیابی نیازهای شنوایی و ارتباطی شما برای تعیین وسیله تقویتی مناسبی که ممکن است نیاز داشته باشید.\n' + '                            <br>\n' + '                            ارزیابی پیشرفت با وسایل کمک شنوایی: متخصص چگونگی کارکرد شما با وسیله کمک شنوایی جدیدتان را برای تعیین اینکه آیا نیاز به تغییراتی دارد یا نه، بررسی میکند.\n' + '                            <br>\n' + '                        </p>'
            }, {
                id: 1,
                question: 'هرچند وقت یکبار باید تست های شنوایی را انجام دهم؟',
                answer: '<p>تست های آنلاین همیشه در دسترس اند، اما انجمن پرشکی آمریکا پیشنهاد میکند چکاب شنوایی را هر 3 سال یکبار انجام دهید.</p>'
            }]
        };
    }
});

/***/ }),

/***/ "DUBT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2000L.fe1be52.mp3";

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var self = this;
    self.axios.get(ApibaseUrl + "api/v1/menus/mainmenu").then(function (response) {
      self.menus = response.data;
    });
  },
  data: function data() {

    return {
      menus: []
    };
  }
});

/***/ }),

/***/ "Foea":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4000L.7a57384.mp3";

/***/ }),

/***/ "FsUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_lang__ = __webpack_require__("VRBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SaveResult_vue__ = __webpack_require__("lJpM");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingShowResult',
    components: { SaveResult: __WEBPACK_IMPORTED_MODULE_2__SaveResult_vue__["a" /* default */] },

    mounted: function mounted() {
        // check user passed prev steps, if not go home!
        if (!window.questionsAnswer || !window.calibrationAnswers || !window.PureToneAnswers || !window.SpeechTestAnswers) this.$parent.$router.replace('/');

        this.lang = __WEBPACK_IMPORTED_MODULE_1__assets_lang__["a" /* default */].Lang;
        this.calculateResult();

        //console.log((this.questionsCount) , (10-this.SpeechTestCount),(this.questionsCount) + (10-this.SpeechTestCount),(this.questionsCount) + (10-this.SpeechTestCount) >= 4);
    },

    data: function data() {

        return {
            canShowResult: false,
            scorePresent: 15,
            scoreText: 'normal',
            resultQuestionsAnswer: [],
            questionPerWrongScore: 6.666666666666667,
            questionsCount: 0,
            resultCalibrationAnswers: [],
            resultPureToneAnswers: [],
            PureToneCount: 0.0,
            PureTonePerWrongScore: 8.333333333333333,
            resultSpeechTestAnswers: [],
            SpeechTestCount: 0,
            SpeechTestPerWrongScore: 3.333333333333333,
            lang: [],
            result_params: []

        };
    },
    methods: {
        calculateResult: function calculateResult() {
            var self = this;

            // QUESTIONS
            this.resultQuestionsAnswer = window.questionsAnswer.filter(function (value) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value).length !== null;
            });
            this.resultQuestionsAnswer.forEach(function (val, key) {
                if (val.answer === 1) {
                    self.questionsCount++;
                }
            });

            // CALIBRATIONS
            this.resultCalibrationAnswers = window.calibrationAnswers;

            //PURE TONES
            this.resultPureToneAnswers = window.PureToneAnswers;
            this.resultPureToneAnswers.forEach(function (val, key) {
                //console.log(val.answer);
                if (val.answer === 0) {
                    self.PureToneCount += window.calibrationAnswers.type === 'speaker' ? 1 : 0.5;
                }
            });

            // SPEECH TEST
            this.resultSpeechTestAnswers = window.SpeechTestAnswers.filter(function (value) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value).length !== null;
            });
            this.resultSpeechTestAnswers.forEach(function (val, key) {
                //console.log(val);
                if (val.answer === 1) {
                    self.SpeechTestCount++;
                }
            });

            self.setScoreText();
        },
        setScoreText: function setScoreText() {
            var self = this;
            self.scorePresent = self.questionsCount * self.questionPerWrongScore + self.PureToneCount * self.PureTonePerWrongScore + (10 - self.SpeechTestCount) * self.SpeechTestPerWrongScore;

            if (self.scorePresent > 75.0) self.scoreText = 'severe';else if (self.scorePresent > 50.0) self.scoreText = 'moderate';else if (self.scorePresent > 25.0) self.scoreText = 'mild';

            if (self.scorePresent < 15) self.scorePresent = 15;

            // for save result send to server
            this.result_params = [{ questionsAnswer: this.resultQuestionsAnswer }, { calibrationAnswers: this.resultCalibrationAnswers }, { pureToneAnswers: this.resultPureToneAnswers }, { speechTestAnswers: this.resultSpeechTestAnswers }, { scorePresent: this.scorePresent }, { scoreText: this.scoreText }];
        }
    }
});

/***/ }),

/***/ "G1xv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['result', 'result_params'],
    data: function data() {
        return {
            valid: true,
            name: '',
            age: '',
            phone: '',
            requiredRules: [function (v) {
                return !!v || 'این فیلد اجباری است!';
            }],
            email: '',
            emailRules: [function (v) {
                return v.length > 0 ? /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'ایمیل وارد شده صحیح نمی باشد!' : true;
            }]

        };
    },
    methods: {
        submit: function submit() {

            //console.log();
            //return false;
            if (this.$refs.form.validate()) {
                var self = this;
                self.axios.get(ApibaseUrl + "api/v1/save_result", {
                    params: {
                        name: this.name,
                        age: this.age,
                        phone: this.phone,
                        email: this.email,
                        result: this.result,
                        params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.result_params)
                    }
                }).then(function (response) {
                    console.log(response);
                });
                self.$emit('showResult');
            }
        },
        clear: function clear() {
            this.$refs.form.reset();
        }
    }
});

/***/ }),

/***/ "HqHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingSteps',
    props: ['currentStep', 'dotCount', 'currentDot'],
    mounted: function mounted() {},
    data: function data() {

        return {
            Questions: 'سوالات',
            Calibration: 'کالیبراسیون',
            Pure_tone_test: 'تست تن',
            Speech_test: 'تست گفتار'
        };
    }
});

/***/ }),

/***/ "JNRN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jrn2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "K4e1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/500.809ff0c.mp3";

/***/ }),

/***/ "KGwu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KsA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',{attrs:{"fluid":"","text-xs-center":"","pa-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md11":"","lg7":""}},[_c('router-view',{staticStyle:{"background-color":"#fff"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kwe6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e5dd80_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KsA5");
function injectStyle (ssrContext) {
  __webpack_require__("JNRN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70e5dd80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e5dd80_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MRRG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-all-container HearingTest-greeting--header"},[_c('h1',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.start_exam))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm6":"","xs12":""}},[_c('div',{staticClass:"HearingTest-greeting--left "},[_c('div',{staticClass:"HearingTest-greeting--subHeader ng-binding"},[_vm._v("آیا فکر میکنید که کم شنوایی دارید؟")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-greeting--content ng-binding"},[_vm._v("تست شنوایی آنلاین ما را انجام دهید یا به یک متخصص شنوایی برای ارزیابی کامل شنوایی در شهر خودتان مراجعه کنید.")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-greeting--reminder ng-binding"},[_vm._v("این تست باید در کمتر از 5دقیقه انجام شود.")])])]),_vm._v(" "),_c('v-flex',{attrs:{"sm6":"","xs12":""}},[_c('div',{staticClass:"HearingTest-greeting--loadingBar"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"id":"start_exam_btn","to":"/hearing-questions"}},[_vm._v(_vm._s(_vm.start_btn))])],1)])],1),_vm._v(" "),_c('div',{staticClass:"HearingTest-greeting--description"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm6":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm6":"","xs12":""}},[_c('div',{staticClass:"description-content-left ng-binding"},[_vm._v("تست شنوایی آنلاین نمیتواند جایگزین یک ارزیابی کامل توسط متخصص شنوایی شناسی باشد اما به بررسی هرگونه کم شنوایی که در حال حاضر دارید کمک میکند.")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm6":"","xs12":"","hidden-xs-only":""}},[_c('div',{staticClass:"description-image-wrap"},[_c('img',{attrs:{"src":__webpack_require__("o9gB")}})])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":"","xs12":""}},[_c('div',{staticClass:"description-content-right ng-binding"},[_vm._v("به محض اتمام آزمون، نتایج تست شنوایی بعلاوه پیشنهاداتی برای مراحل بعدی به شما داده خواهد شد.")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"sm11":"","xs12":"","px-4":""}},[_c('h2',[_vm._v("سوالات رایج در مورد تست شنوایی:")]),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.faq_items),function(item){return _c('v-expansion-panel-content',{key:item.id},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(item.question))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3",domProps:{"innerHTML":_vm._s(item.answer)}})],1)],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_my_style_css__ = __webpack_require__("ugmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_my_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_my_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_sounds_pure_tone_500_mp3__ = __webpack_require__("K4e1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_sounds_pure_tone_500_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_sounds_pure_tone_500_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_sounds_pure_tone_1000_mp3__ = __webpack_require__("hOpo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_sounds_pure_tone_1000_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_sounds_pure_tone_1000_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sounds_pure_tone_2000_mp3__ = __webpack_require__("b1+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sounds_pure_tone_2000_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_sounds_pure_tone_2000_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sounds_pure_tone_4000_mp3__ = __webpack_require__("gw8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sounds_pure_tone_4000_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_sounds_pure_tone_4000_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sounds_pure_tone_500L_mp3__ = __webpack_require__("A7hb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sounds_pure_tone_500L_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_sounds_pure_tone_500L_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sounds_pure_tone_500R_mp3__ = __webpack_require__("aRAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sounds_pure_tone_500R_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_sounds_pure_tone_500R_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_sounds_pure_tone_1000L_mp3__ = __webpack_require__("tPRS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_sounds_pure_tone_1000L_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_sounds_pure_tone_1000L_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sounds_pure_tone_1000R_mp3__ = __webpack_require__("6eFg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sounds_pure_tone_1000R_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_sounds_pure_tone_1000R_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_sounds_pure_tone_2000L_mp3__ = __webpack_require__("DUBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_sounds_pure_tone_2000L_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_sounds_pure_tone_2000L_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sounds_pure_tone_2000R_mp3__ = __webpack_require__("X/+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sounds_pure_tone_2000R_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_sounds_pure_tone_2000R_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_sounds_pure_tone_4000L_mp3__ = __webpack_require__("Foea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_sounds_pure_tone_4000L_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_sounds_pure_tone_4000L_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_sounds_pure_tone_4000R_mp3__ = __webpack_require__("j+mL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_sounds_pure_tone_4000R_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_sounds_pure_tone_4000R_mp3__);









__webpack_require__("7t+N")(window);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuetify___default.a);

// index.js or main.js

//import 'bootstrap-rtl/dist/css/bootstrap-rtl.css'


var originalVueComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component = function (name, definition) {
    if (name === 'bFormCheckboxGroup' || name === 'bCheckboxGroup' || name === 'bCheckGroup' || name === 'bFormRadioGroup') {
        definition.components = { bFormCheckbox: definition.components[0] };
    }
    originalVueComponent.apply(this, [name, definition]);
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component = originalVueComponent;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

//console.log(process.env.NODE_ENV);

window.ApibaseUrl =  false ? 'http://192.168.1.101:8000/' : 'http://online-hearing-test-server.persia-tone.com/';

// import sounds





window.pure_tone = [];
window.pure_tone['tone500'] = __WEBPACK_IMPORTED_MODULE_10__assets_sounds_pure_tone_500_mp3___default.a;
window.pure_tone['tone1000'] = __WEBPACK_IMPORTED_MODULE_11__assets_sounds_pure_tone_1000_mp3___default.a;
window.pure_tone['tone2000'] = __WEBPACK_IMPORTED_MODULE_12__assets_sounds_pure_tone_2000_mp3___default.a;
window.pure_tone['tone4000'] = __WEBPACK_IMPORTED_MODULE_13__assets_sounds_pure_tone_4000_mp3___default.a;













window.pure_tone_lr = [];
window.pure_tone_lr['tone500L'] = __WEBPACK_IMPORTED_MODULE_14__assets_sounds_pure_tone_500L_mp3___default.a;
window.pure_tone_lr['tone500R'] = __WEBPACK_IMPORTED_MODULE_15__assets_sounds_pure_tone_500R_mp3___default.a;
window.pure_tone_lr['tone1000L'] = __WEBPACK_IMPORTED_MODULE_16__assets_sounds_pure_tone_1000L_mp3___default.a;
window.pure_tone_lr['tone1000R'] = __WEBPACK_IMPORTED_MODULE_17__assets_sounds_pure_tone_1000R_mp3___default.a;
window.pure_tone_lr['tone2000L'] = __WEBPACK_IMPORTED_MODULE_18__assets_sounds_pure_tone_2000L_mp3___default.a;
window.pure_tone_lr['tone2000R'] = __WEBPACK_IMPORTED_MODULE_19__assets_sounds_pure_tone_2000R_mp3___default.a;
window.pure_tone_lr['tone4000L'] = __WEBPACK_IMPORTED_MODULE_20__assets_sounds_pure_tone_4000L_mp3___default.a;
window.pure_tone_lr['tone4000R'] = __WEBPACK_IMPORTED_MODULE_21__assets_sounds_pure_tone_4000R_mp3___default.a;

window.questionsAnswer = null;
window.calibrationAnswers = null;
window.PureToneAnswers = null;
window.SpeechTestAnswers = null;

window.token = null;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
    created: function created() {

        var self = this;
        self.axios.get(ApibaseUrl + "api/v1/init").then(function (response) {
            self.initData = response.data.result;
            //window.token = response.data.result.token;
            self.axios.defaults.headers.common = {
                'X-CSRF-TOKEN': response.data.result.token,
                'X-Requested-With': 'XMLHttpRequest'
            };
            document.title = self.initData.site_name;
        });
    },
    data: {
        initData: []
    }

});

/***/ }),

/***/ "PceH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PpaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingSpeechTest_vue__ = __webpack_require__("enHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b68cf52_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingSpeechTest_vue__ = __webpack_require__("wltd");
function injectStyle (ssrContext) {
  __webpack_require__("jtIr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b68cf52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingSpeechTest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b68cf52_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingSpeechTest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RTvC":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "SbS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingCalibrationHeadphone_vue__ = __webpack_require__("ptB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455beec7_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingCalibrationHeadphone_vue__ = __webpack_require__("AcTv");
function injectStyle (ssrContext) {
  __webpack_require__("5KHr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-455beec7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingCalibrationHeadphone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455beec7_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingCalibrationHeadphone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TZsr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingCalibrations"}},[_c('HearingSteps',{attrs:{"current-step":"Calibration","dot-count":_vm.calibrations.length,"currentDot":_vm.currCount}}),_vm._v(" "),(_vm.calibrationType == '')?_c('div',{attrs:{"id":"calibration"}},[_vm._m(0),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticStyle:{"margin-left":"50px"},attrs:{"id":"first-btn","sm4":"","xs8":""}},[_c('v-btn',{staticClass:"question-btn",attrs:{"block":""},on:{"click":function($event){_vm.calibrationType = 'headphone'}}},[_vm._v(_vm._s(_vm.headphone))])],1),_vm._v(" "),_c('v-flex',{attrs:{"sm4":"","xs8":""}},[_c('v-btn',{staticClass:"question-btn",attrs:{"block":""},on:{"click":function($event){_vm.calibrationType = 'speaker'}}},[_vm._v(_vm._s(_vm.speaker))])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.calibrationType == 'headphone')?_c('Headphone'):_vm._e(),_vm._v(" "),(_vm.calibrationType == 'speaker')?_c('speaker'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-help"},[_c('div',{staticClass:"HearingTest-test--title ng-binding"},[_vm._v("کالیبراسیون صوتی")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--text ng-binding"},[_vm._v("قبل از اینکه تست را آغاز کنید ما باید تعیین کنیم که شما از هدفون استفاده میکنید یا بلندگو. بهتر است که از هدفون استفاده نمایید چراکه آزمون ها برای هرگوش بطور مجزا گرفته میشود، اگر از هدفون استفاده نشود نتیجه مشخصی برای هر گوش بدست نمی آید.")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--textBold ng-binding"},[_vm._v("مهم است که قبل از شروع تست، صدای کامپیوترتان را روی 50 درصد تنظیم کنید. لطفا یک گزینه را انتخاب کنید.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VBx9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "VRBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    Lang: {
        'hello': 'سلام',
        "resultTitle": "نتایج تست شنوایی",
        "subTitle": "نتایج خود را بررسی کنید و به مرحله بعد بروید",
        "glanceText": "نتایج در یک نگاه",
        "glancePerfect": "تبریک! شنوایی شما کاملا نرمال می باشد.",
        "glanceImperfect": "شما افت شنوایی خفیف دارید",
        "glanceModerate": "شنوایی شما در حد متوسط است. ممکن است در موقعیت های مختلف دچار مشکل شوید",
        "glanceSevere": "افت شنوایی شما شدید است که می تواند کیفیت زندگی شما را تحت تأثیر قرار دهد.",
        "normalText": "نرمال",
        "mildText": "خفیف",
        "moderateText": "در حد متوسط",
        "severeText": "شدید",
        "somethingToConsiderTitle": "این را باید در نظر بگیرید!",
        "ourRecommendationTitle": "پیشنهاد ما به شما",
        "overallHealth": "سلامت و کیفیت کلی زندگی شما به طور مستقیم می تواند به سلامت شنوایی تان مرتبط باشد. انجمن پزشکی آمریکا توصیه می کند که به طور منظم بررسی های شنوایی انجام دهید.",
        "adTitle": "مرحله بعدی من چیست؟",
        "adDescription": "Schedule a <strong>FREE</strong> hearing consultation at a location near you.",
        "adPhoneNumber": "<span class='sched-appt-number'>888-928-6151</span>",
        "adButtonText": "<span class='sched-appt-link'>Schedule an appointment</span>",
        "adButtonUrl": "https://starkey.com/find-a-professional",
        "hlGlanceTitle": "نتایج سوالات مشکل شنوایی در مکان های مختلف",
        "hlGood": "بر اساس جواب های شما, نتایج نشان می دهند شما در بیشتر مکان ها به راحتی می شنوید.",
        "hlBad": "بر اساس جواب های شما, نتایج نشان می دهند که ممکن است در بعضی از محیط ها مجبور باشید برای شنیدن تلاش کنید.",
        "hlAnswer_1": 'دنبال کردن و فهمیدن صحبت ها و بحث ها در تلویزیون، رادیو و موبایل ممکن است برای شما مشکل باشد',
        "hlAnswer_2": 'ممکن است برای شنیدن صدای بعضی از افراد دچار چالش شوید',
        "hlAnswer_3": 'بعضی مواقع ممکن است از مردم بخواهید که حرف خود را تکرار کنند',
        "hlAnswer_4": 'شنیدن صداهای نجوا یا افرادی که به آرامی صحبت می کنند ممکن است برای شما دشوار باشد',
        "hlAnswer_5": 'هنگامی که در اطراف گروه های بزرگتر و یا در محیط های با صدای بلند باشید شنیدن مکالمات می تواند برای شما چالش برانگیز باشد',
        "hlGlanceLearnMore": "Learn more >",
        "ptGlanceTitle": "نتایج تست تون خالص",
        "ptGlanceLearnMore": "Learn more >",
        "speechGlanceTitle": "نتایج تست گفتاری",
        "sGood": "بر اساس جواب های شما, نتایج نشان می دهد شما می توانید تفاوت بین کلماتی که صدای مشابه دارند را تشخیص دهید.",
        "sBad": "بر اساس جواب های شما, نتایج نشان می دهد ممکن است در محیط های زیر دچار مشکل شوید:",
        "sGlanceLearnMore": "Learn more >",
        "hlScheduleText": "Call <strong><span class='sched-appt-number'>888-928-6151</span></strong> or click to schedule a <strong>FREE</strong> hearing consultation today.",
        "hlScheduleButtonText": "<span class='sched-appt-link'>Schedule an appointment ></span>",
        "ptTitle": "Pure tone test results",
        "ptScheduleText": "Call <strong><span class='sched-appt-number'>888-928-6151</span></strong> or click to schedule a <strong>FREE</strong> hearing consultation today.",
        "ptScheduleButtonText": "<span class='sched-appt-link'>Schedule an appointment ></span>",
        "ptGood": "بر اساس جواب های شما, نتایج نشان می دهد که شما می توانید انواع صداهای نرم را بشنوید.",
        "ptBad": "بر اساس جواب های شما, نتایج  نشان می دهد که ممکن است برای شنیدن انواع صداها نیاز به تلاش بیشتری داشته باشید.",
        "ptVar1": "شنیدن صدای نرم، صدای نجوا و صدای کودکان ممکن است برای شما دشوار باشد.",
        "ptVar2": "مکالمات با بعضی افراد و رستورانهای شلوغ ممکن است برای شما یک چالش باشد.",
        "ptVar3": "ممکن است برای پیروی از  یک گفتگو نظیر گروه ها، مانند شام خانوادگی و یا بازی های کارتی و ... دشوار باشد.",
        "ptVar4": "مکان های بزرگ مانند تئاتر یا عبادت گاه ها دیگر برای شما لذت بخش نیست زیرا شنیدن و درک آنچه گفته می شود برای شما دشوار است.",
        "sTitle": "نتایج تست گفتاری",
        "sCorrectText": "صحیح",
        "sScheduleText": "Call <strong><strong><span class='sched-appt-number'>888-928-6151</span></strong> or click to schedule a <strong>FREE</strong> hearing consultation today.",
        "sScheduleButtonText": "<span class='sched-appt-link'>Schedule an appointment ></span>",
        "ad2ButtonText": "<a href='/hearing-aid-finder'>Hearing Aid Finder</a>",
        "ad2Title": "بهترین راه حل برای من چیست؟",
        "ad2Description": "Learn more about hearing aid styles, features, and accessories that might be right for you.",
        "printText": "پرینت نتیجه من >",
        "mediaText": "به اشتراک بگذارید:",
        "reminder": "The hearing test simulator is for informational purposes and is not intended as a diagnostic evaluation. For a complete test and evaluation of your hearing you should visit a qualified and licensed hearing care professional.",
        "speechEnvironmentsCrowd": "در جمعیت",
        "speechEnvironmentsCar": "ماشین",
        "speechEnvironmentsParty": "مهمانی",
        "speechEnvironmentsRestaurant": "رستوران",
        "speechEnvironmentsMeeting": "ملاقات",
        "speechEnvironmentsConversation": "گفتگو",
        "speechEnvironmentsHome": "خانه",
        "untreatedHearingBoldText": "بزرگسالان می توانند با درمان کم شنوایی خود 30-40% درصد توانایی های شناختی اجتماعی را بیشتر تجربه کنند.",
        "untreatedHearingStandardText": "می توانند تا 30-40% درصد توانایی های شناختی را بیشتر تجربه کنند.",
        "researchConfirmsBold": "تحقیقات نیز تایید می کنند",
        "researchConfirmsStandard": "که کاهش شنوایی می تواند بسیاری از این بیماری ها را متوقف کند یا منجر به بهبود روابط، اعتماد به نفس و کیفیت زندگی شود.",
        "submitButtonTextNormal": "دانلود راهنمای رایگان من",
        "submitButtonTextMild": "دانلود راهنمای رایگان من",
        "submitButtonTextModerate": "ارسال",
        "submitButtonTextSevere": "ارسال",
        "resultsRecommendTextWithHtmlNormal": "To learn more about better hearing,&nbsp;download our <span class='orange-text'>FREE</span> guide below.",
        "resultsRecommendTextWithHtmlModerate": "بهتر شنیدن را هم اکنون شروع کنید.<br> <span class='orange-text'>امروز</span> تماس بگیرید تا برنامه مشاوره <span class='orange-text'>رایگان</span> شنوایی را برنامه ریزی کنید.",
        "formDownloadGuideText": "راهنمای بهتر شنیدن شما برای دانلود آماده است!",
        "formFirstNameFieldLabel": "نام",
        "formLastNameFieldLabel": "نام خانوادگی",
        "formEmailFieldLabel": "ایمیل",
        "formPhoneFieldLabel": "شماره تماس",
        "formZipCodeFieldLabel": "کد پستی",
        "dialogTechUSPhoneNumber": "0912-100-9848",
        "readyForNextStep": "من برای رفتن به مرحله بعدی آماده ام",
        "callNow": "هم اکنون تماس بگیرید",
        "printResults": "پرینت نتایج من"
    }
});

/***/ }),

/***/ "X/+x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2000R.684939d.mp3";

/***/ }),

/***/ "X7o9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index__ = __webpack_require__("42Hy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HearingTest_HearingQuestions__ = __webpack_require__("kRLn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HearingTest_HearingCalibration__ = __webpack_require__("pfPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HearingTest_HearingPureToneTest__ = __webpack_require__("Ccn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HearingTest_HearingSpeechTest__ = __webpack_require__("PpaH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HearingTest_HearingShowResult__ = __webpack_require__("zIUo");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'IndexPage',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Index__["a" /* default */]
    }, {
        path: '/hearing-questions',
        name: 'HearingQuestions',
        component: __WEBPACK_IMPORTED_MODULE_3__components_HearingTest_HearingQuestions__["a" /* default */]
    }, {
        path: '/hearing-calibration',
        name: 'HearingCalibration',
        component: __WEBPACK_IMPORTED_MODULE_4__components_HearingTest_HearingCalibration__["a" /* default */]
    }, {
        path: '/pure_tone_test',
        name: 'HearingPureToneTest',
        component: __WEBPACK_IMPORTED_MODULE_5__components_HearingTest_HearingPureToneTest__["a" /* default */]
    }, {
        path: '/speech_test',
        name: 'HearingSpeechTest',
        component: __WEBPACK_IMPORTED_MODULE_6__components_HearingTest_HearingSpeechTest__["a" /* default */]
    }, {
        path: '/show_result',
        name: 'HearingShowResult',
        component: __WEBPACK_IMPORTED_MODULE_7__components_HearingTest_HearingShowResult__["a" /* default */]
    }]
}));

/***/ }),

/***/ "Yeu6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ZOtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingCalibrationSpeaker_vue__ = __webpack_require__("uCPj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd63f210_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingCalibrationSpeaker_vue__ = __webpack_require__("la+5");
function injectStyle (ssrContext) {
  __webpack_require__("X7o9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd63f210"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingCalibrationSpeaker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd63f210_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingCalibrationSpeaker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZYeF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/continuousDiscourse_L.589c739.mp3";

/***/ }),

/***/ "ZpaP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingQuestions"}},[_c('HearingSteps',{attrs:{"current-step":"Questions","dot-count":_vm.questions.length,"currentDot":_vm.currQuestion}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}],attrs:{"id":"loading-spinner"}},[_c('icon',{attrs:{"name":"spinner","pulse":""}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],attrs:{"id":"question"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.currTitle))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticStyle:{"margin-left":"50px"},attrs:{"id":"first-btn","sm4":"","xs8":""}},[_c('v-btn',{staticClass:"question-btn",attrs:{"block":""},on:{"click":function($event){_vm.answerQuestion(1)}}},[_vm._v(_vm._s(_vm.yes)+" > ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"sm4":"","xs8":""}},[_c('v-btn',{staticClass:"question-btn",attrs:{"block":""},on:{"click":function($event){_vm.answerQuestion(0)}}},[_vm._v(_vm._s(_vm.no)+" > ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a+XP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingPureToneTestHeadphone',
    props: ['starting'],
    components: {},
    created: function created() {
        //console.log(starting);
        this.curAudio = this.tones["500L"];
    },
    data: function data() {

        return {
            curAudio: null,
            earSide: 'L',
            tones: {
                '500L': new Audio(window.pure_tone_lr.tone500L),
                '500R': new Audio(window.pure_tone_lr.tone500R),
                '1000L': new Audio(window.pure_tone_lr.tone1000L),
                '1000R': new Audio(window.pure_tone_lr.tone1000R),
                '2000L': new Audio(window.pure_tone_lr.tone2000L),
                '2000R': new Audio(window.pure_tone_lr.tone2000R),
                '4000L': new Audio(window.pure_tone_lr.tone4000L),
                '4000R': new Audio(window.pure_tone_lr.tone4000R)
            },
            currTone: 500,
            curCounterTone: 0,
            answers: [],
            intervals: null,
            timeCounter: 0,
            loadingTone: true,
            nextBtn: false,
            started: false,
            answered: false,
            volL: 0,
            volR: 0
        };
    },

    methods: {
        startTest: function startTest() {

            var self = this;

            this.started = true;

            this.nextBtn = false;

            clearInterval(this.intervals);

            this.timeCounter = 0;

            this.intervals = setInterval(function () {
                //let volL =((self.curCounterTone <= 1) ? window.calibrationAnswers.data.leftSecond :window.calibrationAnswers.data.leftFirst)/ 100;


                this.volL = (window.calibrationAnswers.data.leftFirst - window.calibrationAnswers.data.leftSecond) / 100;
                //let volR = ((self.curCounterTone <= 1) ? window.calibrationAnswers.data.rightSecond :window.calibrationAnswers.data.rightFirst)/ 100;
                this.volR = (window.calibrationAnswers.data.rightFirst - window.calibrationAnswers.data.rightSecond) / 100;

                console.log(window.calibrationAnswers.data.leftFirst, window.calibrationAnswers.data.leftSecond, volL);
                console.log(window.calibrationAnswers.data.rightFirst, window.calibrationAnswers.data.rightSecond, volR);

                var volPlus = self.earSide === 'L' ? volL : volR;
                var volume = volPlus + (self.curCounterTone > 1 ? self.curCounterTone - 1 : 0) / 20;

                volume = volume > 1 ? 1 : volume;
                console.log(volPlus, volume);
                self.curAudio.volume = volume;
                self.curAudio.play();

                self.test += 1;

                if (self.curAudio.readyState <= 2) return false;

                self.checkAudioForPlay();
            }, 100);
        },
        checkAudioForPlay: function checkAudioForPlay() {
            this.loadingTone = false;

            this.nextBtn = false;
            // if timeCounter is 0 so play this audio
            if (this.timeCounter === 0) {
                this.playAudio();
            }

            // plus timeCounter
            this.timeCounter += 100;

            // if 3 seconds is done. so next audio
            if (this.timeCounter >= 3000) {
                this.timeCounter = 0;
                return false;
            }
        },
        playAudio: function playAudio() {

            this.curAudio.pause();
            this.curAudio.currentTime = 0;
            if (this.currTone === 4000 && this.curCounterTone === 4) {
                if (!this.answered) this.answers.push({
                    'tone': this.currTone + this.earSide,
                    'answer': 0
                });
                this.saveAndNextStep();
                return false;
            }
            if (this.curCounterTone === 4) {
                this.loadingTone = true;

                if (!this.answered) this.answers.push({
                    'tone': this.currTone + this.earSide,
                    'answer': 0
                });

                this.answered = false;

                this.currTone *= 2;
                this.curAudio = this.tones[this.currTone + this.earSide];
                this.curCounterTone = 0;
                this.nextBtn = true;
            }

            var volume = (this.earSide === 'L' ? this.volL : this.volR) + (this.curCounterTone > 1 ? this.curCounterTone - 1 : 0) / 20;
            volume = volume > 1 ? 1 : volume;

            this.curAudio.volume = volume;
            this.curAudio.play();
            this.curCounterTone++;
        },
        nextTest: function nextTest() {

            this.answered = true;
            this.loadingTone = true;
            // mines 1 because  this.curCounterTone is always plussed 1
            //console.log("called! nextTest -->  ",this.currTone,this.answers);

            this.answers.push({
                'tone': this.currTone + this.earSide,
                'answer': this.curCounterTone
            });

            this.curCounterTone = 4;

            this.startTest();
        },
        saveAndNextStep: function saveAndNextStep() {

            this.loadingTone = true;
            this.timeCounter = 0;
            if (this.earSide === 'L') {
                this.earSide = 'R';
                this.currTone = 500;
                this.curCounterTone = 0;
                this.curAudio = this.tones["500R"];

                this.nextBtn = true;
                //this.startTest();
                //console.log("GO Right");
            } else {
                clearInterval(this.intervals);
                /// save and go next
                //console.log('PureToneAnswers', this.answers);
                window.PureToneAnswers = this.answers;
                this.$parent.$router.replace('/speech_test');
            }
        }
    }
});

/***/ }),

/***/ "aRAB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/500R.6525a00.mp3";

/***/ }),

/***/ "asVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save-result divider-result"},[_c('v-card',{attrs:{"color":"grey lighten-3"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"text-align":"center","font-size":"22px","color":"#00b7c6"}},[_vm._v("چنانچه نیاز دارید ریز نتایج بدست آمده از آزمون خود را ببینید، لطفا فرم زیر را پر بفرمایید.")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","xs6":""}},[_c('v-text-field',{attrs:{"box":"","label":"نام و نام خانوادگی","rules":_vm.requiredRules,"required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","xs6":""}},[_c('v-text-field',{attrs:{"box":"","label":"سن","rules":_vm.requiredRules,"required":""},model:{value:(_vm.age),callback:function ($$v) {_vm.age=$$v},expression:"age"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","xs6":""}},[_c('v-text-field',{attrs:{"box":"","label":"شماره تماس","rules":_vm.requiredRules,"required":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","xs6":""}},[_c('v-text-field',{attrs:{"box":"","label":"ایمیل","rules":_vm.emailRules},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"success","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("ذخیره")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b1+O":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2000.9386827.mp3";

/***/ }),

/***/ "cWxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingPureToneTestHeadphone_vue__ = __webpack_require__("a+XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15582c3f_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingPureToneTestHeadphone_vue__ = __webpack_require__("0die");
function injectStyle (ssrContext) {
  __webpack_require__("qiS0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15582c3f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingPureToneTestHeadphone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15582c3f_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingPureToneTestHeadphone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cg9i":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAADuklEQVRYhd3XXYhVVRQH8N8up2YcooyICAKjL9A+wNIs36qhHtIJU5kwCumpeogKJPqwIvsQRHopSiioHgTTMJOEZIoecrAHg4zSMok0kywHGoZhapzdwz73c845995JIfrD4d6z915r//faa//3OvzHEHJbt+5pzzqCmYLbcQuuwxU4C8fwNYawEz/U2bDsxlyXM9qbuQBBP17CnJze87P2gWzMRjyFsTKXZ/wLOg9gawGZZvTiUXyImaeD0By8iTM7tOsTPHvqCMXqcyf+xh8Y6ZDUSqE4Sp3lUOUIRPvxshShCdGkYBbuwmUtvHQTuk4NIeZjtaAP59YRHcbHeA7LsaTQQ/SNEAuj2gmhfmyWjnQzZmElluJhKXFvqyNRie4YHhNNFk3Sbg5145UCMvXowVoMNrQmMt9jGfaWOciPUJzScp5gdgsyFVxc938cB7EFG0R/tjLOJzRVv3+XVHdBG4QOSqL4ruhFwSFMtGGHoi2LU54JSdgOt/B3XPQ8FovelrapbTLFhPKxW7QAb+CQpEMVHMF7uEmwPXv/stpbWVioewrQ3imrOTiGB6Xk7ccmrBG9ipE6nbofY9n7OVKUSu+wCjpT6hqxMXwuac8GU9X6KGZjG/YL9uGFbCGl6ESHAi7BpOgIfhXcKxqtjqidzl7BZklIK9ZPZ/+eKZuk3Qgtxx58i+8EQ4IlouEGurVnUQOZGlaIunJkpYrWEUrF1+am1oXYJrgVn+VYFd1VM4RQGoT8ztpKe7C+kCrrGiaP1d/d+DHHZidxPE95ywnVcCWuLum/Qd7tni7bO6RtnsSoVD890kA8B622rMQ0649TxlyfET0ube21GBENC1aJTuIjSf3bJFSb4oBgL+YVEBqSRLKCefgCZ2d+7hZ8kPVtx+JMOgbVVwN1KM8hxkWrcTJn1F94QqNiz6+SSX5eky7bAcHipnG5aEeHBqVPnCcxV4rfPqwVDTVdA811zkXSCb28qT1vgS0JzcV8QZeUlFsyAhG/4FJcI5UYu6Xvrp9z/CzKacvNnzJC92GjUBd+pl6KtfdR0SrsEBzAVUUTZthU1FF07NfQRKYcvYLHBWOie6QI5iPaJVpX1F0UoQs6IFNBjxSzr0QLBQOSBHRLeXdCysf3ldRIRYQKk64ESSwC2eW7vtpaUv80o2jLfpoGoRMNpKaJIkI7puFr1/Rp1FBUU78lfSa3h+gw3jl9hJKerNAeqd+wVHS04cNgmigTxk9xMx5CHy5UW8CkVF9/QnidmFdq/D/wD4vB7bN8t3YiAAAAAElFTkSuQmCC"

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ "enHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps_vue__ = __webpack_require__("35rQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingCalibration',

    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_awesome_components_Icon_vue__["a" /* default */],
        HearingSteps: __WEBPACK_IMPORTED_MODULE_0__steps_vue__["a" /* default */]
    },
    mounted: function mounted() {
        // check user passed prev steps, if not go home!
        if (!window.questionsAnswer || !window.calibrationAnswers || !window.PureToneAnswers) this.$parent.$router.replace('/');
        this.init();
    },
    data: function data() {

        return {
            loaded: false,
            startedTest: false,
            speeches: {},
            curSpeech: null,
            curSpeechCounter: 0,
            curAudio: null,
            answers: []
        };
    },

    watch: {},
    methods: {
        init: function init() {
            var _this = this;

            var self = this;
            self.axios.get(ApibaseUrl + "api/v1/hearing_speech_words").then(function (response) {
                self.speeches = response.data.result;
                self.speeches.forEach(function (value, key) {
                    value.audio = new Audio(value.audio);
                });

                _this.showQuestion();

                self.loaded = true;
            });
            //"audio": new Audio('http://localhost:8000/media/sounds/speechs/01shir.mp3')
        },
        startTest: function startTest() {
            this.startedTest = true;
            this.playSpeechSound();
        },
        showQuestion: function showQuestion() {

            this.curSpeech = this.speeches[this.curSpeechCounter];

            this.curAudio = this.curSpeech.audio;

            var volume = 1;
            if (window.calibrationAnswers.type === 'headphone') {
                volume = (window.calibrationAnswers.data.leftFirst + window.calibrationAnswers.data.rightFirst) / 2 / 100;
            } else {
                volume = window.calibrationAnswers.data.first / 100;
            }

            this.curAudio.volume = volume;
        },
        playSpeechSound: function playSpeechSound() {
            this.curAudio.play();
        },
        nextQuestion: function nextQuestion(word) {

            this.curAudio.pause();
            this.currentTime = 0;
            this.answers[this.curSpeech.id] = {
                'answer': this.curSpeech.answer === word ? 1 : 0,
                'answerText': this.curSpeech.answer
            };

            if (this.curSpeechCounter < this.speeches.length - 1) {

                this.curSpeechCounter++;
                this.showQuestion();
                this.playSpeechSound();
            } else {
                this.doneTest();
            }
        },
        doneTest: function doneTest() {
            window.SpeechTestAnswers = this.answers;
            console.log("all is done!", this.answers);
            this.$parent.$router.replace('/show_result');
        }
    }
});

/***/ }),

/***/ "fWsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps_vue__ = __webpack_require__("35rQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingQuestions',

    components: {
        HearingSteps: __WEBPACK_IMPORTED_MODULE_0__steps_vue__["a" /* default */]
    },
    mounted: function mounted() {
        var self = this;
        self.axios.get(ApibaseUrl + "api/v1/hearing_questions").then(function (response) {
            self.questions = response.data.result;
            self.showQuestion();
            self.loaded = true;
        });
    },
    data: function data() {
        return {
            loaded: false,
            yes: 'بلی',
            no: 'نه',
            questions: {},
            currQuestion: 1,
            currTitle: '',
            answers: []
        };
    },

    methods: {
        showQuestion: function showQuestion() {
            //console.log(this.questions[this.currQuestion]);
            this.currTitle = this.questions[this.currQuestion - 1].title;
        },
        answerQuestion: function answerQuestion(answer) {
            //console.log(this.currQuestion , this.questions.length , this.currQuestion < this.questions.length);

            this.answers[this.questions[this.currQuestion - 1].id] = {
                'question': this.questions[this.currQuestion - 1].id,
                'answer': answer
            };

            if (this.currQuestion < this.questions.length) {
                this.currQuestion++;
                this.showQuestion();
            } else {
                this.loaded = false;
                this.nextStep();
            }
        },
        nextStep: function nextStep() {
            // save Question Answers
            window.questionsAnswer = this.answers;
            //console.log(this.$parent,);
            this.$parent.$router.replace('/hearing-calibration');
            //console.log("go next Step!",window.questionsAnswer);
        }
    }
});

/***/ }),

/***/ "gw8a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4000.2376d1f.mp3";

/***/ }),

/***/ "h/h/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/continuousDiscourse_R.a3b486e.mp3";

/***/ }),

/***/ "hOpo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1000.5bcf04a.mp3";

/***/ }),

/***/ "j+mL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4000R.e967abe.mp3";

/***/ }),

/***/ "jtIr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jtgy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kRLn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingQuestions_vue__ = __webpack_require__("fWsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6830a4da_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingQuestions_vue__ = __webpack_require__("ZpaP");
function injectStyle (ssrContext) {
  __webpack_require__("KGwu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6830a4da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingQuestions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6830a4da_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingQuestions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lJpM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SaveResult_vue__ = __webpack_require__("G1xv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180d2aca_hasScoped_false_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveResult_vue__ = __webpack_require__("asVm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SaveResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180d2aca_hasScoped_false_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "la+5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingCalibrationSpeaker"}},[_c('div',{staticClass:"HearingTest-test--title"},[_c('span',[_c('icon',{attrs:{"name":"volume-up"}})],1),_vm._v(" "),_c('span',[_vm._v("کالیبراسیون صوتی")])]),_vm._v(" "),_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curCalibration == 'first'),expression:"curCalibration == 'first'"}],staticClass:"HearingTest-test--text"},[_c('strong',[_vm._v("بر روی گزینه اجرا کلیک کنید")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curCalibration == 'second'),expression:"curCalibration == 'second'"}],staticClass:"HearingTest-test--text"},[_c('strong',[_vm._v("بر روی گزینه اجرا کلیک کنید")]),_vm._v(" "),_c('br'),_vm._v(" صدا را تنظیم کنید تا جاییکه "),_c('strong',[_vm._v("به سختی")]),_vm._v(" بتوانید صدا را بشنوید.\r\n            "),_c('br'),_vm._v("در مورد تشخیص مواردی که گفته میشود نگران نباشید، لطفا فقط تمرکز کنید که آیا صدایی وجود دارد یا نه؟\r\n      ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curCalibration == 'first'),expression:"curCalibration == 'first'"}],staticClass:"HearingTest-test--calibrationContainer clearfix",attrs:{"id":"firstCalibration"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volumeContainer",on:{"click":function($event){_vm.lowerVolume(5,6)}}},[_c('div',{staticClass:"HearingTest-test--volumeControlContainer"},[_c('div',{staticClass:"HearingTest-test--volumeControl"},[_c('icon',{attrs:{"name":"minus-circle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeButton ng-binding"},[_vm._v("ملایمتر")])])]),_vm._v(" "),_c('v-flex',{staticClass:"play-volume",attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{staticClass:"HearingTest-test--spinner"},[_c('div',{staticClass:"HearingTest-test--playButtonContainer",class:{'Active': _vm.showVolumeAdjusters}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showVolumeAdjusters),expression:"!showVolumeAdjusters"}],staticClass:"HearingTest-test--playButton",on:{"click":function($event){_vm.audioCalibrationPlay()}}},[_c('span',{staticClass:"play-icon"},[_c('icon',{attrs:{"name":"play"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volume"},[_vm._v(_vm._s(_vm.currVolShow())+"%")])]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBar",class:{'Active': _vm.showVolumeAdjusters}})])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volumeContainer",on:{"click":function($event){_vm.raiseVolume(5,96)}}},[_c('div',{staticClass:"HearingTest-test--volumeControlContainer"},[_c('div',{staticClass:"HearingTest-test--volumeControl"},[_c('icon',{attrs:{"name":"plus-circle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeButton"},[_vm._v("بلندتر")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--textButton",on:{"click":function($event){_vm.nextCalibrationPart()}}},[_c('span',[_vm._v("ادامه")]),_vm._v("  >")])])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curCalibration == 'second'),expression:"curCalibration == 'second'"}],staticClass:"HearingTest-test--calibrationContainer clearfix",attrs:{"id":"secondCalibration"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volumeContainer",on:{"click":function($event){_vm.lowerVolume(1,1)}}},[_c('div',{staticClass:"HearingTest-test--volumeControlContainer"},[_c('div',{staticClass:"HearingTest-test--volumeControl"},[_c('icon',{attrs:{"name":"minus-circle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeButton ng-binding"},[_vm._v("ملایمتر")])])]),_vm._v(" "),_c('v-flex',{staticClass:"play-volume",attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{staticClass:"HearingTest-test--spinner"},[_c('div',{staticClass:"HearingTest-test--playButtonContainer",class:{'Active': _vm.showVolumeAdjusters}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showVolumeAdjusters),expression:"!showVolumeAdjusters"}],staticClass:"HearingTest-test--playButton",on:{"click":function($event){_vm.audioCalibrationPlay()}}},[_c('span',{staticClass:"play-icon"},[_c('icon',{attrs:{"name":"play"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volume"},[_vm._v(_vm._s(_vm.currVolShow())+"%")])]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--spinnerBar",class:{'Active': _vm.showVolumeAdjusters}})])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],attrs:{"sm4":"","xs6":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--volumeContainer",on:{"click":function($event){_vm.raiseVolume(1,_vm.MaxVol)}}},[_c('div',{staticClass:"HearingTest-test--volumeControlContainer"},[_c('div',{staticClass:"HearingTest-test--volumeControl"},[_c('icon',{attrs:{"name":"plus-circle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--volumeButton"},[_vm._v("بلندتر")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVolumeAdjusters),expression:"showVolumeAdjusters"}],staticClass:"HearingTest-test--textButton",on:{"click":function($event){_vm.saveCalibrations()}}},[_c('span',[_vm._v("ادامه   >")])])])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("صدا را کم و زیاد کنید تا جاییکه احساس کنید سطح شنیداری صدا برای شما "),_c('strong',[_vm._v("راحت و مناسب")]),_vm._v(" است.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f47c48_hasScoped_false_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("sPmK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f47c48_hasScoped_false_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mmsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingShowResult"}},[_c('div',{attrs:{"id":"ShowResult"}},[_c('v-layout',{staticClass:"result-body",attrs:{"row":"","wrap":"","justify-center":"","align-center":"","px-4":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.lang.resultTitle))]),_vm._v(" "),_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.lang.subTitle))]),_vm._v(" "),_c('div',{staticClass:"progress-body"},[_c('h2',{staticClass:"glanceText"},[_vm._v(_vm._s(_vm.lang.glanceText))]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--textBold"},[_c('span',{staticClass:"results-word ",class:'results-'+_vm.scoreText},[_vm._v(_vm._s(_vm.lang[_vm.scoreText+'Text']))]),_vm._v(" "),(_vm.scoreText == 'normal')?_c('p',{staticClass:"bold-regular results-text"},[_vm._v(_vm._s(_vm.lang.glancePerfect))]):_vm._e(),_vm._v(" "),(_vm.scoreText == 'mild')?_c('p',{staticClass:"bold-regular results-text"},[_vm._v(_vm._s(_vm.lang.glanceImperfect))]):_vm._e(),_vm._v(" "),(_vm.scoreText == 'moderate')?_c('p',{staticClass:"bold-regular results-text"},[_vm._v(_vm._s(_vm.lang.glanceModerate))]):_vm._e(),_vm._v(" "),(_vm.scoreText == 'severe')?_c('p',{staticClass:"bold-regular results-text"},[_vm._v(_vm._s(_vm.lang.glanceSevere))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"progress-result-body"},[_c('span',{staticClass:"progress-result-gradient"}),_vm._v(" "),_c('span',{staticClass:"progress-result",style:({right:_vm.scorePresent+'%'})})]),_vm._v(" "),_c('div',{staticClass:"scoreTexts"},[_c('div',{staticClass:"scoreText"},[_vm._v(_vm._s(_vm.lang.normalText))]),_vm._v(" "),_c('div',{staticClass:"scoreText"},[_vm._v(_vm._s(_vm.lang.mildText))]),_vm._v(" "),_c('div',{staticClass:"scoreText"},[_vm._v(_vm._s(_vm.lang.moderateText))]),_vm._v(" "),_c('div',{staticClass:"scoreText"},[_vm._v(_vm._s(_vm.lang.severeText))])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}}),_vm._v(" "),(!_vm.canShowResult)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',[_c('save-result',{attrs:{"result":_vm.lang[_vm.scoreText+'Text'],"result_params":_vm.result_params},on:{"showResult":function($event){_vm.canShowResult = true}}})],1)],1):_vm._e(),_vm._v(" "),(_vm.canShowResult)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"divider-result",attrs:{"xs12":"","xs12":""}},[_c('h2',[_vm._v(_vm._s(_vm.lang.hlGlanceTitle))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText === 'normal'),expression:"scoreText === 'normal'"}]},[_c('span',{staticClass:"good"},[_c('v-icon',{attrs:{"large":"","color":"green"}},[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.hlGood))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText !== 'normal'),expression:"scoreText !== 'normal'"}]},[_vm._v(_vm._s(_vm.lang.hlBad))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText !== 'normal'),expression:"scoreText !== 'normal'"}]},_vm._l((_vm.resultQuestionsAnswer),function(item){return (item.answer === 1)?_c('div',{staticClass:"per-answer"},[_c('span',[_c('v-icon',{attrs:{"large":"","color":"green"}},[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("  "+_vm._s(_vm.lang['hlAnswer_'+item.question]))])]):_vm._e()}))]),_vm._v(" "),_c('v-flex',{staticClass:"divider-result",attrs:{"xs12":""}},[_c('h2',[_vm._v(_vm._s(_vm.lang.ptGlanceTitle))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText === 'normal'),expression:"scoreText === 'normal'"}]},[_c('span',{staticClass:"good"},[_c('v-icon',{attrs:{"large":"","color":"green"}},[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.ptGood))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText !== 'normal'),expression:"scoreText !== 'normal'"}]},[_vm._v(_vm._s(_vm.lang.ptBad))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.PureToneCount >= 1 ),expression:"PureToneCount >= 1 "}],staticClass:"per-answer"},[_c('div',{staticClass:"ptImg"},[_c('img',{attrs:{"src":__webpack_require__("BUbc")}})]),_vm._v(" "),_c('div',{staticClass:"ptTitle"},[_c('span',[_vm._v("  "+_vm._s(_vm.lang['ptVar1']))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.PureToneCount >= 1),expression:"PureToneCount >= 1"}],staticClass:"per-answer"},[_c('div',{staticClass:"ptImg"},[_c('img',{attrs:{"src":__webpack_require__("cg9i")}})]),_vm._v(" "),_c('div',{staticClass:"ptTitle"},[_c('span',[_vm._v("  "+_vm._s(_vm.lang['ptVar2']))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.PureToneCount >= 2),expression:"PureToneCount >= 2"}],staticClass:"per-answer"},[_c('div',{staticClass:"ptImg"},[_c('img',{attrs:{"src":__webpack_require__("VBx9")}})]),_vm._v(" "),_c('div',{staticClass:"ptTitle"},[_c('span',[_vm._v("  "+_vm._s(_vm.lang['ptVar3']))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.PureToneCount >= 3),expression:"PureToneCount >= 3"}],staticClass:"per-answer"},[_c('div',{staticClass:"ptImg"},[_c('img',{attrs:{"src":__webpack_require__("ufqW")}})]),_vm._v(" "),_c('div',{staticClass:"ptTitle"},[_c('span',[_vm._v("  "+_vm._s(_vm.lang['ptVar4']))])])])]),_vm._v(" "),_c('v-flex',{staticClass:"divider-result",attrs:{"xs12":""}},[_c('h2',[_vm._v(_vm._s(_vm.lang.speechGlanceTitle))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","grid-list-xs-center":""}},_vm._l((_vm.resultSpeechTestAnswers),function(item){return _c('v-flex',{key:item.answerText,staticStyle:{"text-align":"center"},attrs:{"sm1":"","xs2":""}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.answer === 1),expression:"item.answer === 1"}],staticClass:"good"},[_c('v-icon',{attrs:{"large":"","color":"green"}},[_vm._v("done")])],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.answer === 0),expression:"item.answer === 0"}],staticClass:"bad"},[_c('v-icon',{attrs:{"large":"","color":"red"}},[_vm._v("close")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(item.answerText))])])})),_vm._v(" "),_c('v-layout',{staticStyle:{"padding":"15px 0"},attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText === 'normal'),expression:"scoreText === 'normal'"}]},[_c('span',{staticClass:"good"},[_c('v-icon',{attrs:{"large":"","color":"green"}},[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.sGood))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText !== 'normal'),expression:"scoreText !== 'normal'"}]},[_vm._v(_vm._s(_vm.lang.sBad))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","grid-list-xs-center":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText !== 'normal'),expression:"scoreText !== 'normal'"}],staticClass:"speechtest-icon-wrap",attrs:{"sm2":"","xs3":""}},[_c('div',{staticClass:"speechtest-icon"},[_c('img',{attrs:{"src":__webpack_require__("Jrn2")}})]),_vm._v(" "),_c('div',{staticClass:"speechtest-text"},[_vm._v(_vm._s(_vm.lang.speechEnvironmentsCrowd))])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText !== 'normal'),expression:"scoreText !== 'normal'"}],staticClass:"speechtest-icon-wrap",attrs:{"sm2":"","xs3":""}},[_c('div',{staticClass:"speechtest-icon"},[_c('img',{attrs:{"src":__webpack_require__("BW0t")}})]),_vm._v(" "),_c('div',{staticClass:"speechtest-text"},[_vm._v(_vm._s(_vm.lang.speechEnvironmentsCar))])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText !== 'normal'),expression:"scoreText !== 'normal'"}],staticClass:"speechtest-icon-wrap",attrs:{"sm2":"","xs3":""}},[_c('div',{staticClass:"speechtest-icon"},[_c('img',{attrs:{"src":__webpack_require__("zsae")}})]),_vm._v(" "),_c('div',{staticClass:"speechtest-text"},[_vm._v(_vm._s(_vm.lang.speechEnvironmentsParty))])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText === 'moderate' || _vm.scoreText === 'severe'),expression:"scoreText === 'moderate' || scoreText === 'severe'"}],staticClass:"speechtest-icon-wrap",attrs:{"sm2":"","xs3":""}},[_c('div',{staticClass:"speechtest-icon"},[_c('img',{attrs:{"src":__webpack_require__("Yeu6")}})]),_vm._v(" "),_c('div',{staticClass:"speechtest-text"},[_vm._v(_vm._s(_vm.lang.speechEnvironmentsRestaurant))])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText === 'moderate' || _vm.scoreText === 'severe'),expression:"scoreText === 'moderate' || scoreText === 'severe'"}],staticClass:"speechtest-icon-wrap",attrs:{"sm2":"","xs3":""}},[_c('div',{staticClass:"speechtest-icon"},[_c('img',{attrs:{"src":__webpack_require__("vB9t")}})]),_vm._v(" "),_c('div',{staticClass:"speechtest-text"},[_vm._v(_vm._s(_vm.lang.speechEnvironmentsMeeting))])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText === 'severe'),expression:"scoreText === 'severe'"}],staticClass:"speechtest-icon-wrap",attrs:{"sm2":"","xs3":""}},[_c('div',{staticClass:"speechtest-icon"},[_c('img',{attrs:{"src":__webpack_require__("uJ+Z")}})]),_vm._v(" "),_c('div',{staticClass:"speechtest-text"},[_vm._v(_vm._s(_vm.lang.speechEnvironmentsConversation))])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.scoreText === 'severe'),expression:"scoreText === 'severe'"}],staticClass:"speechtest-icon-wrap",attrs:{"sm2":"","xs3":""}},[_c('div',{staticClass:"speechtest-icon"},[_c('img',{attrs:{"src":__webpack_require__("RTvC")}})]),_vm._v(" "),_c('div',{staticClass:"speechtest-text"},[_vm._v(_vm._s(_vm.lang.speechEnvironmentsHome))])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h3',{staticClass:"nextStep"},[_vm._v(_vm._s(_vm.lang.somethingToConsiderTitle))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"untreatedHearing",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.lang.untreatedHearingBoldText))]),_vm._v(" "),_c('v-flex',{staticClass:"researchConfirms",attrs:{"xs6":""}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.lang.researchConfirmsBold))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.researchConfirmsStandard))])])],1),_vm._v(" "),_c('h3',{staticClass:"nextStep"},[_vm._v("مرحله بعدی!")]),_vm._v(" "),_c('div',{staticClass:"nextStepContent"},[_c('div',{staticClass:"content-important"},[_vm._v("لطفا جهت هماهنگی و تعیین وقت برای بررسی های حضوری با ما تماس بگیرید!")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://persia-tone.com/index.php/%D8%AA%D9%85%D8%A7%D8%B3-%D8%A8%D8%A7-%D9%85%D8%A7"}},[_vm._v("برای دیدن اطلاعات تماس اینجا کلیک کنید!")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o9gB":
/***/ (function(module, exports) {

module.exports = "../../static/img/hearingtest-screenshot-en-us.d0dab9b.png";

/***/ }),

/***/ "pfPu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingCalibration_vue__ = __webpack_require__("5onB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d15d4492_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingCalibration_vue__ = __webpack_require__("TZsr");
function injectStyle (ssrContext) {
  __webpack_require__("jtgy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d15d4492"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingCalibration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d15d4492_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingCalibration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ptB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_L_mp3__ = __webpack_require__("ZYeF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_L_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_L_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_sounds_calibration_continuousDiscourse_R_mp3__ = __webpack_require__("h/h/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_sounds_calibration_continuousDiscourse_R_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_sounds_calibration_continuousDiscourse_R_mp3__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingCalibrationHeadphone',

    components: {},
    mounted: function mounted() {
        this.currAudio = this.audioL;
        this.currVol = 40;
    },
    data: function data() {

        return {
            audioL: new Audio(__WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_L_mp3___default.a),
            audioR: new Audio(__WEBPACK_IMPORTED_MODULE_1__assets_sounds_calibration_continuousDiscourse_R_mp3___default.a),
            currAudio: null,
            earSide: 'left',
            curCalibration: 'first',
            showVolumeAdjusters: false,
            currVol: 0,
            currVolShow: 0,
            MaxVol: 0,
            speakerAnswer: {
                type: 'headphone',
                data: []
            }
        };
    },

    methods: {
        audioCalibrationPlay: function audioCalibrationPlay() {
            this.showVolumeAdjusters = true;

            this.currAudio.volume = this.currVol / 100;
            this.currAudio.addEventListener('ended', function () {
                this.currentTime = 0;
                this.play();
            }, false);
            this.currAudio.play();
        },
        lowerVolume: function lowerVolume(vol, lower) {

            if (this.currVol > lower) this.currAudio.volume = ((this.currVol -= vol) / 100).toFixed(2);
        },
        raiseVolume: function raiseVolume(vol, riser) {
            if (this.curCalibration === "second") riser = riser >= 10 ? riser - 4 : riser / 2;
            if (this.currVol < riser) this.currAudio.volume = ((this.currVol += vol) / 100).toFixed(2);
        },
        nextCalibrationPart: function nextCalibrationPart() {
            this.currAudio.pause();
            this.currAudio.currentTime = 0;

            switch (this.earSide) {
                case 'left':
                    if (this.curCalibration === "first") {
                        this.speakerAnswer.data['leftFirst'] = this.currVol;
                        this.MaxVol = Math.ceil(this.currAudio.volume * 100);
                        //console.log(this.currVol, this.currAudio.volume);
                        this.currVol = Math.ceil(this.currAudio.volume * 50);
                        this.currAudio.volume = parseFloat((this.currVol / 100).toFixed(2));

                        this.curCalibration = "second";
                    } else {
                        this.speakerAnswer.data['leftSecond'] = this.currVol;
                        this.curCalibration = "first";
                        this.currAudio = this.audioR;
                        this.currVol = 40;
                        this.currAudio.volume = (this.currVol / 100).toFixed(2);
                        this.earSide = 'right';
                    }
                    break;
                case 'right':
                    if (this.curCalibration === "first") {
                        this.speakerAnswer.data['rightFirst'] = this.currVol;

                        this.MaxVol = Math.ceil(this.currAudio.volume * 100);
                        //console.log(this.currVol, this.currAudio.volume);
                        this.currVol = Math.ceil(this.currAudio.volume * 50);
                        this.currAudio.volume = parseFloat((this.currVol / 100).toFixed(2));

                        this.curCalibration = "second";
                    } else {
                        this.speakerAnswer.data['rightSecond'] = this.currVol;
                        this.saveCalibrations();
                    }
                    break;
            }

            this.showVolumeAdjusters = false;
        },
        saveCalibrations: function saveCalibrations() {
            this.currAudio.pause();
            this.currAudio.currentTime = 0;
            window.calibrationAnswers = this.speakerAnswer;
            //console.log("save calibrationAnswers Headphone",window.calibrationAnswers);
            this.$parent.$router.replace('/pure_tone_test');
        }
    }
});

/***/ }),

/***/ "qiS0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sPmK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"toggleable":"md","type":"dark","variant":"info"}},[_c('b-nav-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"href":"#"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-nav',{attrs:{"is-nav-bar":""}},[_c('b-nav-item',[_c('router-link',{attrs:{"to":"/","exact":"","tag":"span"}},[_vm._v("Home")])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{attrs:{"to":"/about","tag":"span"}},[_vm._v("About")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sSgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tPRS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1000L.59c21dd.mp3";

/***/ }),

/***/ "uCPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_RL_mp3__ = __webpack_require__("vXKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_RL_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_RL_mp3__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingCalibrationSpeaker',

    components: {},
    mounted: function mounted() {
        //console.log(window.calibrationType);
    },
    data: function data() {

        return {
            curCalibration: "first",
            audio: new Audio(__WEBPACK_IMPORTED_MODULE_0__assets_sounds_calibration_continuousDiscourse_RL_mp3___default.a),
            showVolumeAdjusters: false,
            currVol: 40,
            MaxVol: 0,
            speakerAnswer: {
                type: 'speaker',
                data: []
            }
        };
    },

    /*watch:{
        currVol: function (val) {
            this.currVol = parseFloat(val.toFixed(2));
        }
    },*/
    methods: {
        audioCalibrationPlay: function audioCalibrationPlay() {
            this.showVolumeAdjusters = true;
            this.audio.volume = this.currVol / 100;
            this.audio.addEventListener('ended', function () {
                this.currentTime = 0;
                this.play();
            }, false);
            this.audio.play();
        },
        lowerVolume: function lowerVolume(vol, lower) {

            if (this.currVol > lower) this.audio.volume = ((this.currVol -= vol) / 100).toFixed(2);

            //console.log('lowerVolume',this.currVol ,this.audio.volume);
        },
        raiseVolume: function raiseVolume(vol, riser) {
            if (this.curCalibration === "second") riser = riser >= 10 ? riser - 4 : riser / 2;
            if (this.currVol < riser) this.audio.volume = ((this.currVol += vol) / 100).toFixed(2);
            //console.log('raiseVolume',this.currVol ,this.audio.volume);
        },
        nextCalibrationPart: function nextCalibrationPart() {
            this.audio.pause();
            this.audio.currentTime = 0;
            this.speakerAnswer.data['first'] = this.currVol;
            this.MaxVol = this.audio.volume * 100;
            this.currVol = Math.ceil(this.audio.volume * 50);
            this.audio.volume = (this.currVol / 100).toFixed(2);
            this.showVolumeAdjusters = false;
            this.curCalibration = "second";

            //console.log("next");
        },
        saveCalibrations: function saveCalibrations() {
            this.audio.pause();
            this.audio.currentTime = 0;
            this.speakerAnswer.data['second'] = this.currVol;
            window.calibrationAnswers = this.speakerAnswer;
            //console.log("save calibrationAnswers Speaker",window.calibrationAnswers);
            this.$parent.$router.replace('/pure_tone_test');
        },
        currVolShow: function currVolShow() {
            return parseInt(this.currVol);
        }
    }
});

/***/ }),

/***/ "uJ+Z":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAEcklEQVRoge3ZXahVRRQH8N/4kUqW9mGRkISlSZkSWSZ+UJSIhtCDRYSVGEE9WBgEvVgmvvRBmoFFD5mJBkUEVho+FGakZhHag5WGJWGpkUmmXu/1Tg9zzj0f95x7z973CAXnD5tz9szaa63/nrVm1symhRZaaOH/hJBJ+v2djcvGLu1zcTtuwFgMxQnsE+0RfCb6WNAplj0/b3Im1wZkks6GmXgOU2r0XYxRuAOLBTvxDLbkNdYv74O94BHBJkypeMvVCBT6J2MzFuU1eC6ITMXriqNdDN5Y9VvLl2AlZuQx2jwiUdHJ5WINvaHqt7q95M/Tecw3L0eKYRLtFXwtJfQw0XjBeFzRoJ6r0B9ns5hvZrIPFsxCuzRDDcIp7MLbUnIvxqW96PkbnVmNN4vINKzApG49wWzp7a7Ho3gBo7vJFafraJ2eMqkOmkHkemzERT3I9MeDGC1aJngD51VIpFzZiNV5nGhGsj+mZxLlmCY4H3srWqN2vCK6T46wIuuI1BrwYERGm8OlPDiJX7BdsBrfZNRTgWaE1hbc26DsWdEhQRRNwEFBexN8aEJoRWuwtkHppwR3Yzd+ahYJmpMjnVgoWig5eKYqBE9iG2ZLM9vloq0VEkX5UHZlRLNW9k6skabfiYJ1hfblovGiGfiksGA+hC/LnG2KD31XUll6dOB7aRrdK1qGAxWywY+CQ5iOj/At3sJ1fXGj+WV8Wti2iRYI2ivCrBRCs/AhBhbuJ2CORO6HPGabQWQKFmAkjmCt6HMcrsyVUBy1QFyqSKKEEVgimp/Hib4RCZZiifIQDRbiVdFixcIvULYIDcGVdTReK+TIdH3JkeAuPFtHxyLB/IoZKHZdbThaR+uv5fuBLMhLJIie7NZaaf/hOvrPil6q0d6G53P6k5vIYFxTs6dEZqK0N69EGqX1mIfv8Du+EN2GHVU6GkZeIh2CU3WcLOJP0cmqSJmKN7EB+ySy40TTcVmh/TXptCUT8iZ7Oz7Q87Z0k7SqFzFasBkXFO5vFE0UHBdcLW2+hoFgEm7O4lC2ESmfUKIV0uJXC78V+ssxVokEjBMsK/xfpUiiJJsJ+UIrETpSiOt3RX/gNI5Jq/pU7K+onULNyH9cGok5Ve2Z9uvkC60LpTc2QNCGF7FRdIngmLQyD8OtBYf2SwRrTblD8ECN9r+yOpWVyE2CdzCm69Qkve0Oyel+GFh2XAoHC6v1dsFXuKUBO1t7F6lE1tB6GWO67krODpBOTQZWtKdgGiVYhU7RE9LusDtKgfdzodjMhKxEJvQqUZ4JJaIjBUOxQzRTOh5tq3guOIH1hf4DMqL51W/tUilKR6JEO6XkHiMaLgjSfuaotIfPhaxETkqHB7VdrV/vdRSucpl9GW33iKyhtaduT89F6yH8k9FWJmQl8l5mCylnNshVQTWObETSceanGW3skj4znFNkHZF20f3Y3qD8btwjOl22HzknY5Nn1jqMO6WvS3OlA+lBZf1ncFAqGlfieB99bKGFFlpo4b+LfwE5tRKjxLl9pgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "ufqW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAFT0lEQVRYhe2Ya2wUVRTHf3dmZ1/d0m23td3W1rYUwquwAgmvUGkMiiQSEo1EYsCY+AgmGDXGCDHGxxcxPuIHH/EDRjSaAPGDiYhGBREiARSK5RkJSGuwEAot7dLd7lw/3J3d2d3ZF/iR/6c7c88987/nnHvOuQO3UBgiNdq2v5iEBR8wB7gLiACTgcak5L/AKaAH2IPkAIKrqZXSpk9maX1wHgCuMsg3A08Cq4COPDIhYBqwMrmZ88DXwIfAiVI+opUo8xxwCNjoSEZKMLO3DKhNrAcOAG8A/psl1AR8A7wN1DlKJEyq3QZhvxsSZj49AWAjgp9QFrwBQoK5CPYAy/PKmJKwz807nS18HGmjI+DNZykL84BfgfvKJdQAbAfaCmkHmGDohH0GIY+LWrdLua8wqoGvgOlOk05BrSP4FGgpphlNcHJwhM3nLtLi9fDbwFXwGEWXARMQfAEsBoYzVOaICtYD95ai1ULY66bRZ4DIzREFMAt4PftlNqEm4OWSVZqSgNfNuvZ61rbW0TTBXyyGsrEOySx7TkoTEoBgHcrHpSFhsmFqI5MCHqoNnU2dzeUSMhC8YE++aUISH7C6HDJTaip4flI49Wp1c4jucBDGE6XpUNxXIGnIJQSzgdZSFelC8OaMFtya4JVj/Tx9+BwSeKuzGb9h5JYGJyjLVCJYkktI0F0SGYCESaQmwIpwkFeP91PjdjG/JsAzR84xJ1jBPeEqSJRoJYW7rYH92EdKXi7Ap2u8drwfr67xRFsdEoibkpd6+5K7LOvEdVoDu8sml7xc0zg8eI2g4eLFyWEW7TpO23dHWHNHiDur/OwaGAK9lDKZQioQ7UEddhR1Qnycjkof6zvqkcD8UAVdtZXETclDt9ewsLYSYvHS4kihwhqkXSaK2FhKGDdBE0RqK2n3ezAlaAI+iLRmiIa9BnPrqjh4dRTiCXBpxZJmatJu1wFHUVNCPIEhNB5oqWVn11T2dU+nrcJDXDpX96Dh4tvFU9i3ZBqPTqwnoOuKWP4cNWIN7EF9GpiaTSZouFjVHuKp9tuIBFU7EzMl8QIJcNw0kUgWhAIsCAXYMKWRT84MsOXvS1yIxkHPsVbKGHYL9WSIJEwWhAL8sXQGH81uJRL0k0hWcjOrog+MxTkfjdneiJQxElIyKeBl08wWDi/tZGVTtXJ9Jo45EdqdIWJKJga8tPo9qY8u33uKi2PjGJraoSE0zo6OMfvHXmbu7OHAoGV5iSYEcVNy/77T9A5FAaj3GMyo8ju1KD/nEpLsBy7Ypexu6YvG+P6fQfqvx9CTAaoJODF8nf7hKFeiMQ5ahIRAF3AtYbKj/zJ/jYyl9MRyXX3dmZBgGNiWLW0haLhY1lRDlaFnuEwXSWaawGWdJKmMYAjBsqYaGrwFe6QfgLPWQzqo1TfeR/AYyWbcsB3V9goPOxalc6c76Ta/LQF6k2O3JvDqGgGXlrHGvs6GTfYHex4CddLeBTaiCc6MjrG173LOlmKmSe9wlK19l+kZGlU5RoO9l4bxaYI/h6J8ef4SQSOzIRXA0aGosqjC56geO4sGwPbURdGPCvC5mHmvN0qpKZUGy0qWvCaUz5yWJt0LnEUyD+vI51wU04tHgUcQ7EcTVWSb2H77zJ5Lf4wixTUBrEXkJuN8FfAkkoeBKzkzZRVxR8SBx4FfnCYLleQdSLqA32+aQhpnUBeIzfkEivUIR5F0A+8BsSKyxfAZsAhbzrkRQgBDwLNIFgJbgMEySIygfjYsAdaSlXidUM7fj0PAGtRVqQvoRnV6DUAlKrquoX7JHEOd1N0oN93C/4b/AAKKhhSe2OSkAAAAAElFTkSuQmCC"

/***/ }),

/***/ "ugmZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vB9t":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAE4UlEQVRoge3Xb6ifZRkH8M91dtBzzoiFZ0rOQ8xVznTmcg3SaovKM522Qk47/VMxNnMvoqKCCAwRDCEiI4aaDdaLkM0Jo2JMLV0LMsGKCLNmjWVtwxguGbqx0KsXz/17fs/vOb+zvepF8Hzhx3nu+77u6/p+r/t6ruc+dOjQoUOHDh06dOjQ4f8MYdczZ7MgwWLhQenD+AO+hN83LN8r/A6nhztpIfMcXIXfNGbfLdyHK6Vf4PM41uIxFCOt8buwXXgK38f5xckItkk3CYuwRtiNieJjp/C09AQm5w9XYxJP4GlhB0aECeyW1mCRcBO2NTieXzg9he2Fa43miVyKXwoXUKv/rbAW/8Er0thActNy/EN4rd4TrsNjDZvGgdQP62TubXgax1vxl1bmT2ERRrEfqxrr/8Ja/JnBE7mLARGEVfiidFo6Wq9lbXNKOImHy/hZaV/LprEne799eLasPlwInxoQXv2OCqeFL2NVKzEXCHf1bEfKwwJhZa22l7iKwNoy+hSON4R/BS9Kq3FYuBZ3Y3VJQh9zX5HVwt24VjgsrBZeLD57OF5iktbU4po+00ppgWS0ZO0NHBOWD4SrjA8UBxdjM94kHRVewHuk7dJleF6YlRaXk5wf4Xsl3g7pq1gv3IrdeE66ECeEi6VncADTdZL7pXescB94Rz4h7BwImF7FdDnaGeln+GgR9pz0N2Gh9KF6B98WXsdlspRLP/iY8CdpgfC1OsfpSbwqvE26vNj/FDdil/Bd6XEsbCVkIx7pC+mX0q34Bi4RnidmyZfxz0YWdgj3Y5+0HweETWX9XizDxlpAT94ggZ3SQXy9zPwQy/EBfFDYgtnGCUzhvBL7ndIBfEv4Uc9/72Vfgq24CFer+vg1qm61SbpPOULMYm8hNCZMlID3CktrEcPQr/ONWFqEEyaEc4vVXmm2PL9RYm8qXK6RrsTVwkXSVmkJVVt7i/QrLCvqx/DNSmluxadxBw4Jy+oSqf6uFB4Ufq2q4Q2tRtEXoDFf4ZPCT/AFvIaZOjn9vYdU7fUBVZV8Rvp3aRR3FvvrpPeNYIuqHHpB78TNOAfrytwSHB5opxVOSj+XVmBDa22QfA5ZSxuky4uPk3P2Vx1tSRmtK5xulrUIhfuWUayoJ/sZfED6rP5XegJHWjRexmbhO9LMAIGBj+Accm1Bd2AxPic8JJ3X2HsEE2U8WRrA+4f4XTFCXZtNTKi6VW/DJE7URMJxVSv+mDQz0ON7z/Pdi5ofvD5miq/NON44wRPSZOM0pwu3dnLOHS3tsx+gXQLV3CW4X7gCr2CbcCNuGVIuw9EU1xTTP71bpNdVpX4b3ox9ZXw2LByVxgdIDAvIVSKeJH9MjMt8BDeclXxz7Uzl1n++TXVN+rjqynIhHjpjmVZz4yPC2Blo9DaOy5wqz7sGRLQRhpXOIImmqLZduAGPltEUjUQPs68wNoKpOcHn3msOlvB7ZK4fEnw4hmdv+N+eTTVejz1ldHCg3OfeBQlTI9JLc455sFT243bcg+vnJdx2fqZyaxKfK6I3f71wj3B74TBXfD/hL40KH5Heobr4XSEsLUT+KuyRHpN+IEzjiCxu2p1pGPHmy9z+OLbFZmsPIU3j76r/O9YJ66W3F5tD0h/L3e2FeZPVoUOHDh06dOjQoUOHDv9j/BflmaCKYq1ZtAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "vXKz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/continuousDiscourse_RL.3ff14b7.mp3";

/***/ }),

/***/ "wltd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HearingSpeechTest"}},[_c('HearingSteps',{attrs:{"current-step":"Speech_test","dot-count":0,"currentDot":0}}),_vm._v(" "),_c('div',{attrs:{"id":"speechTest"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.startedTest),expression:"!startedTest"}],staticClass:"info-help"},[_c('div',{staticClass:"HearingTest-test--part speech-section"},[_c('div',{staticClass:"HearingTest-test--title"},[_vm._v("تست گفتاری")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--text"},[_vm._v("این تست از شما میخواهد کلمه ای که میشنوید را انتخاب کنید، همچنین به تعیین چگونگی شنیدن و تشخیص گفتار در سطح شنوایی نرمال به شما کمک خواهد کرد. ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}],staticClass:"HearingTest-test--button begin-test-btn testBtn"},[_c('icon',{attrs:{"name":"spinner","pulse":""}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticClass:"HearingTest-test--button begin-test-btn testBtn",on:{"click":function($event){_vm.startTest();}}},[_c('span',[_vm._v("شروع تست")]),_vm._v(" >")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.curSpeech !== null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.startedTest),expression:"startedTest"}],staticClass:"HearingTest-test--part speech-section"},[_c('div',{staticClass:"HearingTest-test--title"},[_vm._v("کدام را می شنوید؟")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--text"},[_vm._v("لطفا کلمه ای که می شنوید را انتخاب کنید.")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.curSpeech.words),function(word,key){return _c('v-flex',{key:word.id,attrs:{"sm3":"","xs6":""}},[_c('div',{staticClass:"HearingTest-test--button",on:{"click":function($event){_vm.nextQuestion(word)}}},[_vm._v(_vm._s(word))])])}))],1),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--textButton ng-binding",on:{"click":function($event){_vm.playSpeechSound();}}},[_c('icon',{attrs:{"name":"repeat"}}),_vm._v(" پخش مجدد کلمه\n      ")],1)],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wx6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__ = __webpack_require__("lfLh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//this is saved
/*
 window.questionsAnswer
window.calibrationAnswers
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    NavBar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "xJDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps_vue__ = __webpack_require__("35rQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HearingPureToneTestHeadphone_vue__ = __webpack_require__("cWxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HearingPureToneTestSpeaker_vue__ = __webpack_require__("0nfB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HearingPureToneTest',

    components: {
        HearingSteps: __WEBPACK_IMPORTED_MODULE_0__steps_vue__["a" /* default */],
        Headphone: __WEBPACK_IMPORTED_MODULE_1__HearingPureToneTestHeadphone_vue__["a" /* default */],
        speaker: __WEBPACK_IMPORTED_MODULE_2__HearingPureToneTestSpeaker_vue__["a" /* default */]
    },
    mounted: function mounted() {
        // check user passed prev steps, if not go home!
        if (!window.questionsAnswer || !window.calibrationAnswers) this.$parent.$router.replace('/');

        //TODO: be ok in Hereee!
        this.audioType = window.calibrationAnswers ? window.calibrationAnswers.type : 'speaker';
    },
    data: function data() {

        return {
            audioType: 'speaker',
            started: false,
            currTest: 1,
            answers: []
        };
    },

    methods: {
        startPureToneTest: function startPureToneTest() {
            this.started = true;
            //this.$root.$emit('startingTest');
        }
    }
});

/***/ }),

/***/ "xYyD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z655":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HearingTest"},[_c('div',{staticClass:"HearingTest-test"},[_c('v-container',{staticClass:"HearingTest-test--sections",attrs:{"grid-list-md":"","pa-0":"","pb-3":""}},[_c('v-layout',{attrs:{"raw":"","wrap":""}},[_c('v-flex',{attrs:{"md3":"","sm3":"","xs6":""}},[_c('div',{staticClass:"HearingTest-test--section",class:{ Active: _vm.currentStep == 'Questions'}},[_c('div',{staticClass:"HearingTest-test--sectionText"},[_c('span',[_vm._v("1. ")]),_vm._v(_vm._s(_vm.Questions)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--partDots"},_vm._l((_vm.dotCount),function(dot){return _c('div',{staticClass:"pull-left"},[_c('div',{staticClass:"HearingTest-test--partDot",class:{ Active: _vm.currentDot == dot}})])}))])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":"","sm3":"","xs6":""}},[_c('div',{staticClass:"HearingTest-test--section",class:{ Active: _vm.currentStep == 'Calibration'}},[_c('div',{staticClass:"HearingTest-test--sectionText"},[_c('span',[_vm._v("2. ")]),_vm._v(_vm._s(_vm.Calibration))]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--partDots"},_vm._l((_vm.dotCount),function(dot){return _c('div',{staticClass:"pull-left"},[_c('div',{staticClass:"HearingTest-test--partDot",class:{ Active: _vm.currentDot == dot}})])}))])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":"","sm3":"","xs6":""}},[_c('div',{staticClass:"HearingTest-test--section",class:{ Active: _vm.currentStep == 'Pure_tone_test'}},[_c('div',{staticClass:"HearingTest-test--sectionText"},[_c('span',[_vm._v("3. ")]),_vm._v(_vm._s(_vm.Pure_tone_test))]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--partDots"},_vm._l((_vm.dotCount),function(dot){return _c('div',{staticClass:"pull-left"},[_c('div',{staticClass:"HearingTest-test--partDot",class:{ Active: _vm.currentDot == dot}})])}))])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":"","sm3":"","xs6":""}},[_c('div',{staticClass:"HearingTest-test--section",class:{ Active: _vm.currentStep == 'Speech_test'}},[_c('div',{staticClass:"HearingTest-test--sectionText"},[_c('span',[_vm._v("4. ")]),_vm._v("\n          "+_vm._s(_vm.Speech_test))]),_vm._v(" "),_c('div',{staticClass:"HearingTest-test--partDots"},_vm._l((_vm.dotCount),function(dot){return _c('div',{staticClass:"pull-left"},[_c('div',{staticClass:"HearingTest-test--partDot",class:{ Active: _vm.currentDot == dot}})])}))])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zIUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingShowResult_vue__ = __webpack_require__("FsUY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c40d23d_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingShowResult_vue__ = __webpack_require__("mmsv");
function injectStyle (ssrContext) {
  __webpack_require__("xYyD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c40d23d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearingShowResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c40d23d_hasScoped_true_transformToRequire_video_src_source_src_audio_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HearingShowResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zsae":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.58b2dec012c6d76ca2b3.js